/* tslint:disable */
/* eslint-disable */
// Generated using typescript-generator version 3.2.1263 on 2024-12-03 16:22:26.

export interface GetDueDatesRequestDto {
  agentId: string;
  serviceCode: string;
  subServiceCode: string;
  creationDate: DateAsString;
  amount: number;
  fee: number;
  commission: number;
  agentMoneyFlow: MoneyFlow;
  currencyCode: string;
}

export interface WebStringResponse extends WebResponseEntity<string> {
  result: string;
  problemResponseData?: ProblemResponseData | null;
}

export interface CreateReceivedPaymentDto {
  agentId: string;
  paymentDate: DateAsString;
  amount: number;
  currency: string;
  settlementId: string;
  referenceId: string;
  receivedPaymentType: ReceivedPaymentType;
}

export interface WebBooleanResponse {
  result: boolean;
  problemResponseData?: ProblemResponseData | null;
}

export interface SearchRequest extends Serializable {
  filters: FilterRequest[];
  sorts: SortRequest[];
  page: number;
  size: number;
}

export interface CreateSettlementConfigurationDto {
  name: string;
  description: string;
  settlementExecutionPlan: SettlementExecutionPlan;
  nettingEnabled: boolean;
  baseCurrencyIsoCode: string;
  settlementExchangeRateType: SettlementExchangeRateType;
  exchangeRateDate: ExchangeRateDate;
  settlementNettingSettingList: SettlementConfigurationNettingDto[];
  settlementConfigurationItemList: SettlementConfigurationItemDto[];
  agentId: string;
  validFromDate: DateAsString;
  validToDate: DateAsString;
}

export interface WebUUIDResponse {
  result: string;
  problemResponseData?: ProblemResponseData | null;
}

export interface UpdateSettlementConfigurationDto {
  id: string;
  name: string;
  description: string;
  settlementExecutionPlan: SettlementExecutionPlan;
  nettingEnabled: boolean;
  baseCurrencyIsoCode: string;
  settlementExchangeRateType: SettlementExchangeRateType;
  exchangeRateDate: ExchangeRateDate;
  settlementNettingSettingList: SettlementConfigurationNettingDto[];
  settlementConfigurationItemList: SettlementConfigurationItemDto[];
  agentId: string;
  validFromDate: DateAsString;
  validToDate: DateAsString;
}

export interface SettlementSettingAccountDto {
  settlementSettingId: string;
  accountNumber: string;
  currencyIsoCode: string;
  bankName: string;
  transactionPartType: TransactionPartType;
  serviceCode: string;
}

export interface CreateSettlementSettingDto {
  accountingEnabled: boolean;
  rollingEnabled: boolean;
  amountWithAccountingEnabled: boolean;
  amountWithRollingEnabled: boolean;
  nettingEnabled: boolean;
  onWorkingDayOnly: boolean;
  baseCurrencyIsoCode: string;
  currencyList: SettlementCurrency[];
  accountList: SettlementSettingAccount[];
  settlementExecutionPlan: SettlementExecutionPlan;
}

export interface UpdateSettlementSettingDto {
  id: string;
  accountingEnabled: boolean;
  rollingEnabled: boolean;
  amountWithAccountingEnabled: boolean;
  amountWithRollingEnabled: boolean;
  nettingEnabled: boolean;
  onWorkingDayOnly: boolean;
  baseCurrencyIsoCode: string;
  currencyList: SettlementCurrency[];
  accountList: SettlementSettingAccount[];
  settlementExecutionPlan: SettlementExecutionPlan;
}

export interface CreateSharingArrangementDto {
  name: string;
  description: string;
  validFromDateTime: DateAsString;
  validToDateTime: DateAsString;
  isFinished: boolean;
  isActive: boolean;
  wasActive: boolean;
  agentId: string;
  sharingArrangementModelId: string;
}

export interface UpdateSharingArrangementDto {
  id: string;
  name: string;
  description: string;
  validFromDateTime: DateAsString;
  validToDateTime: DateAsString;
  agentId: string;
  sharingArrangementModelId: string;
}

export interface ActivateDto {
  sharingArrangementModelId: string;
}

export interface CloseDto {
  sharingArrangementModelId: string;
  stateNote: string;
}

export interface CreateSharingArrangementModelDto {
  name: string;
  description: string;
  sharingArrangementModelType: SharingArrangementModelType;
  countryId: string;
  currency: string;
  firstWorkingWeekDay: DayOfWeek;
  counterResetPeriod: CounterResetPeriod;
  modelUnit: SharingArrangementModelUnit;
  platformServiceId: string;
}

export interface DeactivateDto {
  sharingArrangementModelId: string;
}

export interface DeleteSharingArrangementModelItemsDto {
  sharingArrangementModelId: string;
  sharingArrangementModelItemsId: string[];
}

export interface FinishCreatingDto {
  sharingArrangementModelId: string;
}

export interface FinishFormingDto {
  sharingArrangementModelId: string;
}

export interface FinishParametrizingDto {
  sharingArrangementModelId: string;
}

export interface RejectDto {
  sharingArrangementModelId: string;
  stateNote: string;
}

export interface RequestDeactivationDto {
  sharingArrangementModelId: string;
}

export interface ReturnForUpdateDto {
  sharingArrangementModelId: string;
}

export interface SoftDeleteDto {
  sharingArrangementModelId: string;
}

export interface UpdateSharingArrangementCriterionDto {
  sharingArrangementModelId: string;
  sharingArrangementCriterionList: CreateSharingArrangementCriterionDto[];
}

export interface UpdateSharingArrangementModelItemsDto {
  sharingArrangementModelId: string;
  sharingArrangementModelItems: CreateSharingArrangementModelItemsDto[];
}

export interface UpdateSharingArrangementModelDto {
  id: string;
  name: string;
  description: string;
  sharingArrangementModelType: SharingArrangementModelType;
  countryId: string;
  currency: string;
  firstWorkingWeekDay: DayOfWeek;
  counterResetPeriod: CounterResetPeriod;
  modelUnit: SharingArrangementModelUnit;
  platformServiceId: string;
}

export interface VerifyDto {
  sharingArrangementModelId: string;
}

export interface CreateSharingArrangementParameterDto {
  id: string;
  name: string;
  modelUnit: SharingArrangementModelUnit;
  dataType: DataType;
  platformServiceId: string;
}

export interface UpdateSharingArrangementParameterDto {
  id: string;
  name: string;
}

export interface CreateSharingArrangementServiceProviderDto {
  name: string;
  description: string;
  validFromDateTime: DateAsString;
  validToDateTime: DateAsString;
  isFinished: boolean;
  isActive: boolean;
  wasActive: boolean;
  serviceProviderId: number;
  sharingArrangementModelId: string;
}

export interface UpdateSharingArrangementServiceProviderDto {
  id: string;
  name: string;
  description: string;
  validFromDateTime: DateAsString;
  validToDateTime: DateAsString;
  serviceProviderId: number;
  sharingArrangementModelId: string;
}

export interface BusinessTransactionInfo {
  internalReferenceNumber: string;
  paymentInfo: PaymentTransactionInfo;
  westernUnionInfo: WesternUnionTransactionInfo;
  agentInfo: SettlementAgentInfo;
  serviceInfo: SettlementServiceInfo;
  agentMoneyFlow: MoneyFlow;
}

export interface PaymentOrderRequestCommissionRequest {
  paymentOrderRequestId: string;
  currency: string;
  amount: number;
  serviceFee: number;
  agentId: string;
  serviceId: string;
  subserviceId: string;
  transactionCount: number;
  totalAmount: number;
}

export interface AdjustmentReasonCodeDto {
  code: string;
  description: string;
  mtcnRef: string;
  adjustmentType: AdjustmentType;
  fullDescription: string;
  comment: string;
  action: string;
}

export interface RecordTypeDto {
  recordTypeValue: number;
  description: string;
}

export interface FileUploadRequest {
  importName: string;
  forDate: DateAsString;
  naid: string;
  fileContent: any[];
}

export interface ConfirmProcessingResultRequest {
  activityDataProcessingId: string;
  resolutionNote: string;
}

export interface WesternUnionTransactionInfo {
  fixed: boolean;
  originatingAmount: number;
  originatingCountry: string;
  originatingCurrencyCode: string;
  destinationAmount: number;
  destinationCountry: string;
  destinationCurrencyCode: string;
  testQuestion: string;
  testAnswer: string;
  additionalService: string;
  requestDateTime: DateAsString;
  charges: number;
  exchangeRate: number;
  expectedPayout: number;
  gross: number;
  messageTolls: number;
  plusCharges: number;
  principal: number;
  discountAmount: number;
  referenceNumber: string;
  newReferenceNumber: string;
  complianceDataBuffer: string;
  client: WesternUnionClient;
  remoteClient: WesternUnionRemoteClient;
  payoutSplitInfo: WesternUnionPayoutSplitInfo;
}

export interface WebResponseEntity<T> {
  result: T;
  problemResponseData?: ProblemResponseData | null;
}

export interface DueDatesResponseDto {
  principalDueDate: DateAsString;
  feeDueDate: DateAsString;
  commissionDueDate: DateAsString;
  principalAmounted: boolean;
  feeAmounted: boolean;
  commissionAmounted: boolean;
}

export interface WebResponseObject<T> extends WebResponseBase {
  result: T;
}

export interface WebListResponseEntity<T> {
  result: T[];
  problemResponseData?: ProblemResponseData | null;
}

export interface AgentAccountCommonDto {
  id: string;
  accountType: AccountType;
  accountStatus: AccountStatus;
  iban: string;
  bban: string;
  agentId: string;
  agentName: string;
  currencyIsoCode: string;
  bankName: string;
  version: number;
}

export interface AgentAssocServiceCommonDto {
  id: string;
  name: string;
  isActive: boolean;
  platformServiceId: string;
  agentId: string;
}

export interface AgentCommonDto {
  id: string;
  name: string;
  registryCode: string;
  taxNumber: string;
  isActive: boolean;
  sharingArrangementsIds: string[];
}

export interface MasterAgentAccountCommonDto {
  id: string;
  accountType: AccountType;
  accountStatus: AccountStatus;
  iban: string;
  bban: string;
  masterAgentId: string;
  masterAgentName: string;
  currencyIsoCode: string;
  bankName: string;
  version: number;
}

export interface SettlementPlatformServiceCommonDto {
  id: string;
  name: string;
  serviceProviderId: number;
  serviceProviderName: string;
  masterAgent: MasterAgentCommonDto;
}

export interface SettlementPlatformSubServiceCommonDto {
  id: string;
  name: string;
  platformService: SettlementPlatformServiceCommonDto;
}

export interface ServiceCountry {
  countryCode: string;
  countryName: string;
}

export interface ServiceCurrency {
  currencyCode: string;
  currencyName: string;
}

export interface MasterAgentCommonDto {
  id: string;
  name: string;
  masterAgentCode: string;
  platformProviderCode: string;
  dueDateConfigurationTypeAccessibility: DueDateConfigurationTypeAccessibility;
}

export interface ServiceProviderInfo {
  id: number;
  serviceCode: string;
  providerName: string;
  description: string;
  accountNumber: string;
}

export interface ReceivedPaymentCommonDto {
  id: string;
  agentId: string;
  paymentDate: DateAsString;
  amount: number;
  currency: string;
  settlementId: string;
  referenceId: string;
  resolvedAmount: number;
  balanceAmount: number;
  receivedPaymentState: ReceivedPaymentState;
  receivedPaymentType: ReceivedPaymentType;
}

export interface PendingBusinessTransactionCommonDto {
  id: string;
  businessTransactionId: string;
  paymentOrderRequestId: string;
  payerFirstName: string;
  payerLastName: string;
  payerAddress: string;
  payerPlace: string;
  payerPostNumber: string;
  recipientName: string;
  recipientAddress: string;
  recipientPlace: string;
  recipientPostNumber: string;
  recipientAccount: string;
  currency: string;
  amount: number;
  fee: number;
  paymentPurpose: string;
  paymentCode: number;
  referenceNumber: string;
  model: number;
  partyType: number;
  executionTime: DateAsString;
  processChannelType: ProcessChannelType;
  masterAgentId: string;
  agentId: string;
  locationId: string;
  userId: string;
  masterAgentUserId: string;
  serviceCode: string;
  subServiceCode: string;
  state: BusinessTransactionState;
  commission: number;
  open: boolean;
}

export interface SettlementEntryCommonDto {
  id: string;
  agentId: string;
  serviceId: string;
  subServiceId: string;
  settlementTransactionType: SettlementTransactionType;
  amount: number;
  convertedAmount: number;
  exchangeRateId: string;
  currencyIsoCode: string;
  settlementId: string;
  settlementDate: DateAsString;
  settlementOrderEntryId: string;
  settlementEntryState: SettlementEntryState;
}

export interface SettlementOrderEntryCommonDto {
  id: string;
  settlementTransactionType: SettlementTransactionType;
  settlementOrderEntryType: SettlementOrderEntryType;
  amount: number;
  currencyIsoCode: string;
  serviceId: string;
  subServiceId: string;
  agentId: string;
  settlementEntries: SettlementEntryCommonDto[];
  settlementOrderId: string;
  settlementOrderEntryState: SettlementOrderEntryState;
  settlementId: string;
  settlementDate: DateAsString;
}

export interface SettlementOrderCommonDto {
  id: string;
  totalAmount: number;
  currencyIsoCode: string;
  recipientType: SettlementOrderRecipientType;
  recipientId: string;
  payerId: string;
  settlementOrderDate: DateAsString;
  masterAgentAccount: string;
  agentAccount: string;
  referenceNumber: string;
}

export interface SettlementTransactionCommonDto {
  id: string;
  businessTransactionId: string;
  transactionType: SettlementTransactionType;
  transactionStatus: SettlementTransactionStatusType;
  isAmounted: boolean;
  agentId: string;
  locationId: string;
  serviceId: string;
  subServiceId: string;
  currency: string;
  amount: number;
  convertedAmount: number;
  exchangeRateId: string;
  debtAmount: number;
  debtCurrency: string;
  resolvedAmount: number;
  balanceAmount: number;
  creationDate: DateAsString;
  settlementDate: DateAsString;
  resolvedRisk: number;
  dueDate: DateAsString;
}

export interface SettlementCommonDto {
  id: string;
  agentId: string;
  settlementState: SettlementState;
  settlementDate: DateAsString;
}

export interface FilterRequest extends Serializable {
  key: string;
  operator: Operator;
  field_type: FieldType;
  value: any;
  value_to: any;
  values: any[];
}

export interface SortRequest extends Serializable {
  key: string;
  direction: SortDirection;
}

export interface Serializable {}

export interface Page<T> extends Slice<T> {
  totalPages: number;
  totalElements: number;
}

export interface SettlementExecutionPlan extends Serializable {
  planName: string;
  planDescription: string;
  settlementPlanType: SettlementPlanType;
  restartPeriod: number;
  continuousStartTime: DateAsString;
  continuousEndTime: DateAsString;
  periodicTimes: PeriodicTime[];
}

export interface SettlementConfigurationNettingDto {
  nettingType: NettingType;
  singleService: boolean;
  agentAssocServiceIdList: string[];
}

export interface SettlementConfigurationItemDto {
  serviceCode: string;
  subServiceCode: string;
  transactionPartType: TransactionPartType;
  currency: string;
  masterAgentAccount: string;
  agentAccount: string;
  dueDateConfiguration: CreateDueDateConfigurationDto;
}

export interface SettlementConfigurationCommonDto {
  id: string;
  name: string;
  description: string;
  settlementExecutionPlan: SettlementExecutionPlan;
  nettingEnabled: boolean;
  baseCurrencyIsoCode: string;
  settlementExchangeRateType: SettlementExchangeRateType;
  exchangeRateDate: ExchangeRateDate;
  settlementConfigurationItemList: SettlementConfigurationItemCommonDto[];
  settlementNettingSettingList: SettlementConfigurationNettingCommonDto[];
  agent: AgentCommonDto;
  state: SettlementConfigurationStateType;
  activationDateTime: DateAsString;
  deactivationDateTime: DateAsString;
  validFromDate: DateAsString;
  validToDate: DateAsString;
  createdAtDateTime: DateAsString;
  createdByUser: string;
  updatedAtDateTime: DateAsString;
  updatedByUser: string;
}

export interface SettlementConfigurationTemplateDto {
  name: string;
  description: string;
  baseCurrencyIsoCode: string;
  settlementExecutionPlan: SettlementExecutionPlan;
  serviceCodeList: string[];
  nettingEnabled: boolean;
  settlementExchangeRateType: SettlementExchangeRateType;
  exchangeRateDate: ExchangeRateDate;
  settlementConfigurationItemList: SettlementConfigurationItemCommonDto[];
  settlementNettingSettingList: SettlementConfigurationNettingCommonDto[];
}

export interface SettlementSettingDto {
  id: string;
  accountingEnabled: boolean;
  rollingEnabled: boolean;
  amountWithAccountingEnabled: boolean;
  amountWithRollingEnabled: boolean;
  nettingEnabled: boolean;
  onWorkingDayOnly: boolean;
  baseCurrencyIsoCode: string;
  currencyList: SettlementCurrency[];
  settlementExecutionPlan: SettlementExecutionPlan;
  accountList: SettlementSettingAccount[];
}

export interface SettlementCurrency extends Serializable {
  currencyIsoCode: string;
  transactionPartType: TransactionPartType;
  serviceCode: string;
}

export interface SettlementSettingAccount extends Serializable {
  currencyIsoCode: string;
  bankName: string;
  transactionPartType: TransactionPartType;
  serviceCode: string;
  accountNumber: string;
}

export interface SharingArrangementCommonDto {
  id: string;
  name: string;
  description: string;
  state: SharingArrangementStateType;
  validFromDateTime: DateAsString;
  validToDateTime: DateAsString;
  agent: AgentCommonDto;
  sharingArrangementModel: SharingArrangementModelBaseCommonDto;
}

export interface SharingArrangementModelCommonDto {
  id: string;
  referenceNumber: string;
  name: string;
  description: string;
  sharingArrangementModelType: SharingArrangementModelType;
  countryId: string;
  currency: string;
  firstWorkingWeekDay: DayOfWeek;
  counterResetPeriod: CounterResetPeriod;
  modelUnit: SharingArrangementModelUnit;
  createdAtDateTime: DateAsString;
  createdByUser: string;
  updatedAtDateTime: DateAsString;
  updatedByUser: string;
  platformService: SettlementPlatformServiceCommonDto;
  sharingArrangementModelEditSnapshots: SharingArrangementModelEditSnapshotCommonDto[];
  sharingArrangementModelState: SharingArrangementModelStateCommonDto;
  sharingArrangementAllowedActions: string[];
  sharingArrangementCriteria: SharingArrangementCriterionCommonDto[];
  sharingArrangementModelItems: SharingArrangementModelItemCommonDto[];
  sharingArrangementModelStateChanges: SharingArrangementModelStateChangeCommonDto[];
}

export interface CreateSharingArrangementCriterionDto {
  name: string;
  sharingArrangementParameterId: string;
  sharingArrangementOperationId: string;
}

export interface CreateSharingArrangementModelItemsDto {
  sharingArrangementCriterionInstances: CreateSharingArrangementCriterionInstanceDto[];
  fixedCommission: number;
  percentageCommission: number;
  minimalCommission: number;
  maximalCommission: number;
  realTime: boolean;
}

export interface CreateSharingArrangementBooleanParameterDto
  extends CreateSharingArrangementParameterDto {}

export interface CreateSharingArrangementStringParameterDto
  extends CreateSharingArrangementParameterDto {
  values: string[];
}

export interface CreateSharingArrangementDecimalParameterDto
  extends CreateSharingArrangementParameterDto {}

export interface CreateSharingArrangementLongParameterDto
  extends CreateSharingArrangementParameterDto {}

export interface CreateSharingArrangementIntegerParameterDto
  extends CreateSharingArrangementParameterDto {
  values: number[];
}

export interface CreateSharingArrangementInstantParameterDto
  extends CreateSharingArrangementParameterDto {}

export interface CreateSharingArrangementDecimalRangeParameterDto
  extends CreateSharingArrangementParameterDto {
  values: string[];
}

export interface CreateSharingArrangementLongRangeParameterDto
  extends CreateSharingArrangementParameterDto {
  values: string[];
}

export interface SharingArrangementParameterCommonDto {
  id: string;
  name: string;
  modelUnit: SharingArrangementModelUnit;
  dataType: DataType;
  fixed: boolean;
  allowedOperations: SharingArrangementParameterAllowedOperationDto[];
  platformService: SettlementPlatformServiceCommonDto;
  createdAtDateTime: DateAsString;
  createdByUser: string;
  updatedAtDateTime: DateAsString;
  updatedByUser: string;
}

export interface SharingArrangementServiceProviderCommonDto {
  id: string;
  name: string;
  description: string;
  state: SharingArrangementStateType;
  validFromDateTime: DateAsString;
  validToDateTime: DateAsString;
  serviceProviderId: number;
  sharingArrangementModel: SharingArrangementModelBaseCommonDto;
}

export interface PaymentTransactionInfo {
  currency: string;
  amount: number;
  fee: number;
  paymentPurpose: string;
  paymentCode: string;
  paymentReferenceNumber: string;
  model: number;
  partyType: PartyType;
  createdAtDateTime: DateAsString;
  recipientName: string;
  recipientAccount: string;
}

export interface SettlementAgentInfo {
  agentId: string;
  locationId: string;
  operatorId: string;
  userId: string;
  terminalId: string;
}

export interface SettlementServiceInfo {
  serviceCode: string;
  subServiceCode: string;
}

export interface CommissionResultResponse {
  commission: number;
  errors: SharingArrangementError[];
}

export interface WesternUnionActivityDataPayoutDto {
  id: string;
  indicator: string;
  accountNumber: string;
  terminalId: string;
  transactionDateTime: string;
  operatorId: string;
  headerId: string;
  paidAmount: number;
  taxes: number;
  wuCardNumber: string;
  recordingDateTime: string;
  sendingCountry: string;
  checkNumber1: number;
  checkNumber2: number;
  checkNumber3: number;
  additionalCheckIndicator: boolean;
  amountCheckNumber1: number;
  amountCheckNumber2: number;
  amountCheckNumber3: number;
  checkNumber1Cached: boolean;
  checkNumber2Cached: boolean;
  checkNumber3Cached: boolean;
  templateID: string;
  activityComplianceReceiverData: ActivityComplianceReceiverDataDto;
  mtcn: number;
}

export interface WesternUnionActivityShortDataPayoutDto {
  id: string;
  indicator: string;
  accountNumber: string;
  terminalId: string;
  transactionDateTime: string;
  operatorId: string;
  headerId: string;
  paidAmount: number;
  sendingCountry: string;
  mtcn: number;
}

export interface WesternUnionActivityDataSendDto {
  id: string;
  indicator: string;
  accountNumber: string;
  terminalId: string;
  transactionDateTime: string;
  operatorId: string;
  headerId: string;
  statusCode: ActivityDataStatus;
  wuCardNumber: string;
  principal: number;
  charges: number;
  plusCharges: number;
  taxes: number;
  messageCharges: number;
  intendedPayoutCountry: number;
  templateID: string;
  activityComplianceSenderData: ActivityComplianceSenderDataDto;
  mtcn: number;
}

export interface WesternUnionActivityShortDataSendDto {
  id: string;
  indicator: string;
  accountNumber: string;
  terminalId: string;
  transactionDateTime: string;
  operatorId: string;
  headerId: string;
  statusCode: ActivityDataStatus;
  principal: number;
  charges: number;
  intendedPayoutCountry: number;
  mtcn: number;
}

export interface WesternUnionSettlementDataDto {
  id: string;
  recordType: string;
  agentSurrogate: string;
  direction: SettlementDataDirection;
  reportingDate: number;
  transactionProductCode: string;
  transactionCurrency: string;
  recordingCountryCode: string;
  payoutCountryCode: string;
  payoutRateRecordingCountry: number;
  payoutRatePayoutCountry: number;
  settlementRateRecordingCountry: number;
  settlementRatePayoutCountry: number;
  agentAccountNumber: string;
  intraAgentAccountNumber: string;
  intraAgentAccountIndicator: string;
  productCode: string;
  recordingDate: number;
  payoutDate: number;
  fixedIndicator: string;
  fixedSettlementRate: number;
  recordedCurrencyCode: string;
  payoutCurrencyCode: string;
  transactionStatus: SettlementDataStatus;
  recordedPrincipalInUSD: number;
  recordedChargesInUSD: number;
  clearPrincipalInUSD: number;
  clearOfChargesInUSD: number;
  clearOfFXInUSD: number;
  recordedPrincipalInRecordedCurrency: number;
  recordedChargesInRecordedCurrency: number;
  clearPrincipalInRecordedCurrency: number;
  clearChargesInRecordedCurrency: number;
  clearFXInRecordedCurrency: number;
  recordedPrincipalInLocalCurrency: number;
  recordedChargesInLocalCurrency: number;
  clearPrincipalInLocalCurrency: number;
  clearChargesInLocalCurrency: number;
  clearFXInLocalCurrency: number;
  recordedPrincipalInPayoutCurrency: number;
  recordedChargesInPayoutCurrency: number;
  clearPrincipalInPayoutCurrency: number;
  clearChargesInPayoutCurrency: number;
  clearFXInPayoutCurrency: number;
  totalDiscountPremium: number;
  txnAdjustmentLogNumber: string;
  txnAdjustmentSequenceNumber: string;
  txnAdjustmentReInputMTCN: string;
  txnAdjustmentOriginalRecordingDate: number;
  txnAdjustmentOriginalPayoutDate: number;
  txnAdjustmentTypeCode: string;
  txnAdjustmentReasonCode: string;
  txnRecordingHour: number;
  txnRecordingMinutes: number;
  txnPayoutHour: number;
  txnPayoutMinutes: number;
  basicChargesInUSD: number;
  deliveryChargesInUSD: number;
  messageChargesInUSD: number;
  phoneNotificationChargesInUSD: number;
  creditCardChargesInUSD: number;
  countrySurChargeInUSD: number;
  stateTaxInUSD: number;
  cityTaxInUSD: number;
  municipalTaxInUSD: number;
  totalTaxInUSD: number;
  basicChargesInRecordedCurrency: number;
  deliveryChargesInRecordedCurrency: number;
  messageChargesInRecordedCurrency: number;
  phoneNotificationChargesInRecordedCurrency: number;
  creditCardChargesInRecordedCurrency: number;
  countrySurChargeInRecordedCurrency: number;
  stateTaxInRecordedCurrency: number;
  cityTaxInRecordedCurrency: number;
  municipalTaxInRecordedCurrency: number;
  totalTaxInRecordedCurrency: number;
  basicChargesInLocalCurrency: number;
  deliveryChargesInLocalCurrency: number;
  messageChargesInLocalCurrency: number;
  phoneNotificationChargesInLocalCurrency: number;
  creditCardChargesInLocalCurrency: number;
  countrySurChargeInLocalCurrency: number;
  stateTaxInLocalCurrency: number;
  cityTaxInLocalCurrency: number;
  municipalTaxInLocalCurrency: number;
  totalTaxInLocalCurrency: number;
  basicChargesInPayoutCurrency: number;
  deliveryChargesInPayoutCurrency: number;
  messageChargesInPayoutCurrency: number;
  phoneNotificationChargesInPayoutCurrency: number;
  creditCardChargesInPayoutCurrency: number;
  countrySurChargeInPayoutCurrency: number;
  stateTaxInPayoutCurrency: number;
  cityTaxInPayoutCurrency: number;
  municipalTaxInPayoutCurrency: number;
  totalTaxInPayoutCurrency: number;
  quickPayRelationshipChargesInUSD: number;
  quickPayRelationshipChargesInRecordedCurrency: number;
  quickPayRelationshipChargesInLocalCurrency: number;
  quickPayRelationshipChargesInPayoutCurrency: number;
  payoutSideTax: number;
  partnerText: string;
  spareField4: number;
  spareField5: number;
  spareField6: string;
  spareField7: number;
  spareField8: number;
  spareField9: number;
  bankoDoBrasilIndicator: string;
  settlementCycle: string;
  settlementDate: number;
  senderCity: string;
  senderStateCode: string;
  receiverCity: string;
  receiverStateCode: string;
  commercialCompany: string;
  headerId: string;
  ruc_OOC: string;
  mtcn: string;
  atmtxnIndicator: string;
}

export interface WesternUnionSettlementShortDataDto {
  id: string;
  recordType: string;
  transactionProductCode: string;
  intraAgentAccountIndicator: string;
  recordingCountryCode: string;
  recordedCurrencyCode: string;
  recordedPrincipalInRecordedCurrency: number;
  recordedChargesInRecordedCurrency: number;
  payoutCountryCode: string;
  payoutCurrencyCode: string;
  recordedPrincipalInPayoutCurrency: number;
  recordedChargesInPayoutCurrency: number;
  headerId: string;
  mtcn: string;
}

export interface WesternUnionActivityDataHeaderDto {
  id: string;
  importName: string;
  naid: string;
  forDate: DateAsString;
  description: string;
  partNumber: number;
  totalSent: number;
  totalPaid: number;
  isProcessed: boolean;
}

export interface WesternUnionSettlementDataHeaderDto {
  id: string;
  fileName: string;
  naid: string;
  forDate: DateAsString;
  currencyCode: string;
  networkAgentId: string;
  countryCode: string;
  settlementRate: number;
  confirmationCount: number;
  sharedCostCount: number;
  newCodesCount: number;
  recordedPrincipalTotal: number;
  invoiceTotal: number;
  isProcessed: boolean;
}

export interface WesternUnionActivityProcessingResultDto {
  id: string;
  relatedMTCN: string;
  activityDataHeaderId: string;
  activityDataId: string;
  activityIndicator: string;
  inActivityData: boolean;
  inSystemTransaction: boolean;
  conflictExists: boolean;
  processingDate: DateAsString;
  conflictResolutionDate: DateAsString;
  conflictResolutionNote: string;
  resolved: boolean;
  conflictResolverId: string;
  conflictResolverName: string;
  activityProcessingConflicts: WesternUnionActivityProcessingConflictDto[];
  westernUnionConfirmedTransaction: WesternUnionConfirmedTransactionDto;
  mtcn: string;
}

export interface WesternUnionTransactionDto {
  id: string;
  businessTransactionId: string;
  westernUnionTransactionInfo: WesternUnionTransactionInfo;
  agentInfo: SettlementAgentInfo;
  serviceInfo: SettlementServiceInfo;
  agentMoneyFlow: MoneyFlow;
  commission: number;
  principalDueDate: DateAsString;
  feeDueDate: DateAsString;
  commissionDueDate: DateAsString;
  principalAmounted: boolean;
  feeAmounted: boolean;
  processed: boolean;
}

export interface WesternUnionSettlementProcessingResultDto {
  id: string;
  settlementDataHeaderId: string;
  settlementDataId: string;
  recordType: string;
  intraAgentAccountIndicator: string;
  productCode: string;
  inSettlementData: boolean;
  inSystemTransaction: boolean;
  conflictExists: boolean;
  processingDate: DateAsString;
  conflictResolutionDate: DateAsString;
  conflictResolutionNote: string;
  resolved: boolean;
  conflictResolverId: string;
  conflictResolverName: string;
  settlementProcessingConflicts: WesternUnionSettlementProcessingConflictDto[];
  westernUnionConfirmedTransaction: WesternUnionConfirmedTransactionDto;
  mtcn: string;
}

export interface WesternUnionClient {
  clientId: string;
  clientFirstName: string;
  clientMiddleName: string;
  clientLastName: string;
  clientMaternalName: string;
  clientParentName: string;
  clientBirthDate: DateAsString;
  clientCity: string;
  clientCityOfBirth: string;
  clientCountry: string;
  clientCountryOfBirth: string;
  clientIdPermanent: boolean;
  clientIdExpiryDate: DateAsString;
  clientHasIdIssueDate: boolean;
  clientIdIssueDate: DateAsString;
  clientIdIssuer: string;
  clientIdNo: string;
  clientIdCountryOfIssue: string;
  clientIdType: string;
  clientNationality: string;
  clientPersonalId: string;
  clientPhone: string;
  clientPurposeOfTransaction: string;
  clientState: string;
  clientStreet: string;
  clientZip: string;
  clientOccupation: string;
}

export interface WesternUnionRemoteClient {
  remoteClientFirstName: string;
  remoteClientMiddleName: string;
  remoteClientLastName: string;
  remoteClientMaternalName: string;
  remoteClientCity: string;
  remoteClientCountry: string;
}

export interface WesternUnionPayoutSplitInfo {
  hasAmount1: boolean;
  payoutAmount1: number;
  payoutAmount1CurrencyCode: string;
  hasAmount2: boolean;
  payoutAmount2: number;
  payoutAmount2CurrencyCode: string;
}

export interface ProblemResponseData extends Serializable {
  error: boolean;
  problems: ProblemBase[];
}

export interface WebResponseBase extends Serializable {
  problemResponseData: ProblemResponseData;
}

export interface DueDateConfigurationTypeAccessibility {
  accountingAvailable: boolean;
  amountingAvailable: boolean;
  rollingAvailable: boolean;
}

export interface Sort extends Streamable<Order>, Serializable {
  sorted: boolean;
  unsorted: boolean;
}

export interface Pageable {
  offset: number;
  sort: Sort;
  paged: boolean;
  unpaged: boolean;
  pageNumber: number;
  pageSize: number;
}

export interface PeriodicTime extends Serializable {
  periodicStartTime: DateAsString;
}

export interface CreateDueDateConfigurationDto {
  dueDateConfigurationType: DueDateConfigurationType;
}

export interface SettlementConfigurationItemCommonDto {
  id: string;
  serviceCode: string;
  subServiceCode: string;
  transactionPartType: TransactionPartType;
  currency: string;
  masterAgentAccount: string;
  agentAccount: string;
  dueDateConfiguration: DueDateConfigurationCommonDto;
}

export interface SettlementConfigurationNettingCommonDto {
  id: string;
  nettingType: NettingType;
  singleService: boolean;
  agentServiceList: AgentAssocServiceCommonDto[];
}

export interface SharingArrangementModelBaseCommonDto {
  id: string;
  referenceNumber: string;
  name: string;
  description: string;
  sharingArrangementModelType: SharingArrangementModelType;
  firstWorkingWeekDay: DayOfWeek;
  counterResetPeriod: CounterResetPeriod;
  modelUnit: SharingArrangementModelUnit;
  platformService: SettlementPlatformServiceCommonDto;
}

export interface SharingArrangementModelEditSnapshotCommonDto {
  id: string;
  name: string;
  description: string;
  sharingArrangementModelType: SharingArrangementModelType;
  countryId: string;
  currency: string;
  firstWorkingWeekDay: DayOfWeek;
  platformServiceId: string;
  referenceNumber: string;
  counterResetPeriod: CounterResetPeriod;
  modelUnit: SharingArrangementModelUnit;
  updatedByUser: string;
  updatedAtDateTime: DateAsString;
  sharingArrangementModelId: string;
}

export interface SharingArrangementModelStateCommonDto {
  stateType: SharingArrangementModelStateType;
}

export interface SharingArrangementCriterionCommonDto {
  id: string;
  name: string;
  sharingArrangementModelId: string;
  sharingArrangementParameter: SharingArrangementParameterResponseDto;
  sharingArrangementOperation: SharingArrangementOperationDto;
}

export interface SharingArrangementModelItemCommonDto {
  id: string;
  fixedCommission: number;
  percentageCommission: number;
  minimalCommission: number;
  maximalCommission: number;
  realTime: boolean;
  sharingArrangementModelId: string;
  sharingArrangementCriterionInstances: SharingArrangementCriterionInstanceCommonDto[];
}

export interface SharingArrangementModelStateChangeCommonDto {
  id: string;
  sharingArrangementModelId: string;
  sharingArrangementModelStateType: SharingArrangementModelStateType;
  stateChangeDateTime: DateAsString;
  changedByUser: string;
  stateNote: string;
}

export interface CreateSharingArrangementCriterionInstanceDto {
  sharingArrangementCriterionId: string;
  dataType: DataType;
}

export interface SharingArrangementParameterAllowedOperationDto {
  id: string;
  operationName: string;
}

export interface SharingArrangementBooleanParameterCommonDto
  extends SharingArrangementParameterCommonDto {
  values: boolean[];
}

export interface SharingArrangementStringParameterCommonDto
  extends SharingArrangementParameterCommonDto {
  values: string[];
}

export interface SharingArrangementDecimalParameterCommonDto
  extends SharingArrangementParameterCommonDto {}

export interface SharingArrangementLongParameterCommonDto
  extends SharingArrangementParameterCommonDto {}

export interface SharingArrangementIntegerParameterCommonDto
  extends SharingArrangementParameterCommonDto {
  values: number[];
}

export interface SharingArrangementInstantParameterCommonDto
  extends SharingArrangementParameterCommonDto {}

export interface SharingArrangementDecimalRangeParameterCommonDto
  extends SharingArrangementParameterCommonDto {}

export interface SharingArrangementLongRangeParameterCommonDto
  extends SharingArrangementParameterCommonDto {}

export interface SharingArrangementError {}

export interface ActivityComplianceReceiverDataDto {
  id: string;
  firstName: string;
  lastName: string;
  address1: string;
  address2: string;
  city: string;
  country: string;
  havePhoneNumber: string;
  phoneNumber: string;
  senderFirstName: string;
  senderLastName: string;
  postalCode: string;
  idType: string;
  idIssuer: string;
  idNumber: string;
  idIssuedDate: string;
  idExpirationDate: string;
  occupation: string;
  haveIdExpirationDate: string;
  personalId: string;
  birthDate: string;
  comments: string;
  acknowledgement: string;
  countryOfBirth: string;
  senderCountryOfBirth: string;
  senderBirthDate: string;
  senderStreet: string;
  senderCity: string;
  senderPostalCode: string;
  senderCountryCode: string;
  senderPhoneNumber: string;
}

export interface ActivityComplianceSenderDataDto {
  id: string;
  firstName: string;
  lastName: string;
  city: string;
  postalCode: string;
  street: string;
  receiverFirstName: string;
  receiverLastName: string;
  phone: string;
  idType: string;
  idIssuer: string;
  idNumber: string;
  idIssuedDate: string;
  haveIdExpirationDate: string;
  idExpirationDate: string;
  birthDate: string;
  personalId: string;
  countryOfBirth: string;
  occupation: string;
  comments: string;
  acknowledgement: string;
}

export interface WesternUnionActivityProcessingConflictDto {
  id: string;
  conflictName: string;
  activityDataId: string;
  activityDataValue: string;
  systemDataId: string;
  systemDataValue: string;
}

export interface WesternUnionConfirmedTransactionDto {
  id: string;
  businessTransactionId: string;
  westernUnionTransactionInfo: WesternUnionTransactionInfo;
  agentInfo: SettlementAgentInfo;
  serviceInfo: SettlementServiceInfo;
  agentMoneyFlow: MoneyFlow;
  commission: number;
  principalDueDate: DateAsString;
  feeDueDate: DateAsString;
  commissionDueDate: DateAsString;
  principalAmounted: boolean;
  feeAmounted: boolean;
  inActivity: boolean;
  inSettlement: boolean;
}

export interface WesternUnionSettlementProcessingConflictDto {
  id: string;
  conflictName: string;
  settlementDataId: string;
  settlementDataValue: string;
  systemTransactionId: string;
  calculatedValue: string;
}

export interface ResponseEntity<T> {
  result: T;
  problemResponseData?: ProblemResponseData | null;
}

export interface ProblemBase extends Serializable {
  problemCode: number;
  applicationOrigin: string;
  exceptionCode: string;
  message: string;
  details: string;
  type: string;
}

export interface Slice<T> extends Streamable<T> {
  size: number;
  content: T[];
  number: number;
  sort: Sort;
  first: boolean;
  numberOfElements: number;
  pageable: Pageable;
  last: boolean;
}

export interface CreateAccountingDueDateConfigurationDto extends CreateDueDateConfigurationDto {
  dueDateParameters: CreateDueDateParameterDto[];
}

export interface CreateAmountWithAccountingDueDateConfigurationDto
  extends CreateAccountingDueDateConfigurationDto {
  amountParameter: AmountParameter;
}

export interface CreateAmountWithRollingDueDateConfigurationDto
  extends CreateRollingDueDateConfigurationDto {
  amountParameter: AmountParameter;
}

export interface CreateRollingDueDateConfigurationDto extends CreateDueDateConfigurationDto {
  dueDateParameter: CreateDueDateParameterTPlusNDto;
}

export interface DueDateConfigurationCommonDto {
  id: string;
  dueDateConfigurationType: DueDateConfigurationType;
}

export interface SharingArrangementParameterResponseDto {
  id: string;
  name: string;
  modelUnit: SharingArrangementModelUnit;
  dataType: DataType;
  values: SharingArrangementParameterValueDto[];
  platformServiceId: string;
}

export interface SharingArrangementOperationDto {
  id: string;
}

export interface SharingArrangementCriterionInstanceCommonDto {
  sharingArrangementCriterionId: string;
}

export interface CreateSharingArrangementBooleanCriterionInstanceDto
  extends CreateSharingArrangementCriterionInstanceDto {
  value: boolean;
}

export interface CreateSharingArrangementStringCriterionInstanceDto
  extends CreateSharingArrangementCriterionInstanceDto {
  value: string;
}

export interface CreateSharingArrangementDecimalCriterionInstanceDto
  extends CreateSharingArrangementCriterionInstanceDto {
  value: number;
}

export interface CreateSharingArrangementLongCriterionInstanceDto
  extends CreateSharingArrangementCriterionInstanceDto {
  value: number;
}

export interface CreateSharingArrangementIntegerCriterionInstanceDto
  extends CreateSharingArrangementCriterionInstanceDto {
  value: number;
}

export interface CreateSharingArrangementInstantCriterionInstanceDto
  extends CreateSharingArrangementCriterionInstanceDto {
  value: DateAsString;
}

export interface CreateSharingArrangementDecimalRangeCriterionInstanceDto
  extends CreateSharingArrangementCriterionInstanceDto {
  value: string;
}

export interface CreateSharingArrangementLongRangeCriterionInstanceDto
  extends CreateSharingArrangementCriterionInstanceDto {
  value: string;
}

export interface Streamable<T> extends Iterable<T>, Supplier<Stream<T>> {
  empty: boolean;
}

export interface Order extends Serializable {
  direction: Direction;
  property: string;
  ignoreCase: boolean;
  nullHandling: NullHandling;
  ascending: boolean;
  descending: boolean;
}

export interface CreateDueDateParameterDto {
  dueDateType: DueDateType;
}

export interface AmountParameter {
  amount: number;
  addUpTransactionParts: TransactionPartType[];
}

export interface CreateDueDateParameterTPlusNDto extends CreateDueDateParameterDto {
  dueDate: number;
}

export interface AccountingDueDateConfigurationCommonDto extends DueDateConfigurationCommonDto {
  dueDateParameters: DueDateParameterCommonDto[];
}

export interface AmountWithAccountingDueDateConfigurationCommonDto
  extends AccountingDueDateConfigurationCommonDto {
  amountParameter: AmountParameter;
}

export interface AmountWithRollingDueDateConfigurationCommonDto
  extends RollingDueDateConfigurationCommonDto {
  amountParameter: AmountParameter;
}

export interface RollingDueDateConfigurationCommonDto extends DueDateConfigurationCommonDto {
  dueDateParameter: DueDateParameterCommonDto;
}

export interface SharingArrangementParameterValueDto {
  id: string;
}

export interface SharingArrangementBooleanOperationDto extends SharingArrangementOperationDto {
  operationTypeName: string;
}

export interface SharingArrangementStringOperationDto extends SharingArrangementOperationDto {
  operationTypeName: string;
}

export interface SharingArrangementDecimalOperationDto extends SharingArrangementOperationDto {
  operationTypeName: string;
}

export interface SharingArrangementLongOperationDto extends SharingArrangementOperationDto {
  operationTypeName: string;
}

export interface SharingArrangementIntegerOperationDto extends SharingArrangementOperationDto {
  operationTypeName: string;
}

export interface SharingArrangementInstantOperationDto extends SharingArrangementOperationDto {
  operationTypeName: string;
}

export interface SharingArrangementDecimalRangeOperationDto extends SharingArrangementOperationDto {
  operationTypeName: string;
}

export interface SharingArrangementLongRangeOperationDto extends SharingArrangementOperationDto {
  operationTypeName: string;
}

export interface SharingArrangementBooleanCriterionInstanceCommonDto
  extends SharingArrangementCriterionInstanceCommonDto {
  value: boolean;
}

export interface SharingArrangementStringCriterionInstanceCommonDto
  extends SharingArrangementCriterionInstanceCommonDto {
  value: string;
}

export interface SharingArrangementDecimalCriterionInstanceCommonDto
  extends SharingArrangementCriterionInstanceCommonDto {
  value: number;
}

export interface SharingArrangementLongCriterionInstanceCommonDto
  extends SharingArrangementCriterionInstanceCommonDto {
  value: number;
}

export interface SharingArrangementIntegerCriterionInstanceCommonDto
  extends SharingArrangementCriterionInstanceCommonDto {
  value: number;
}

export interface SharingArrangementInstantCriterionInstanceCommonDto
  extends SharingArrangementCriterionInstanceCommonDto {
  value: DateAsString;
}

export interface SharingArrangementDecimalRangeCriterionInstanceCommonDto
  extends SharingArrangementCriterionInstanceCommonDto {
  value: string;
}

export interface SharingArrangementLongRangeCriterionInstanceCommonDto
  extends SharingArrangementCriterionInstanceCommonDto {
  value: string;
}

export interface HttpEntity<T> {
  headers: { [index: string]: string[] };
  body: T;
}

export interface CreateDueDateParameterWeeklyDto extends CreateDueDateParameterDto {
  dayOfWeek: number;
}

export interface CreateDueDateParameterMonthlyDto extends CreateDueDateParameterDto {
  dayOfMonth: number;
}

export interface CreateDueDateParameterQuarterlyDto extends CreateDueDateParameterDto {}

export interface CreateDueDateParameterYearlyDto extends CreateDueDateParameterDto {
  dayOfMonth: number;
  monthOfYear: number;
}

export interface DueDateParameterCommonDto {
  id: string;
  dueDateConfigurationId: string;
  dueDateType: DueDateType;
}

export interface Iterable<T> {}

export interface Supplier<T> {}

export interface Stream<T> extends BaseStream<T, Stream<T>> {}

export interface DueDateParameterTPlusNCommonDto extends DueDateParameterCommonDto {
  dueDate: number;
}

export interface DueDateParameterWeeklyCommonDto extends DueDateParameterCommonDto {
  dayOfWeek: number;
}

export interface DueDateParameterMonthlyCommonDto extends DueDateParameterCommonDto {
  dayOfMonth: number;
}

export interface DueDateParameterQuarterlyCommonDto extends DueDateParameterCommonDto {
  dayOfMonth: number;
}

export interface DueDateParameterYearlyCommonDto extends DueDateParameterCommonDto {
  dayOfMonth: number;
  monthOfYear: number;
}

export interface BaseStream<T, S> extends AutoCloseable {
  parallel: boolean;
}

export interface AutoCloseable {}

export interface HttpClient<O> {
  request<R>(requestConfig: {
    method: string;
    url: string;
    queryParams?: any;
    data?: any;
    copyFn?: (data: R) => R;
    options?: O;
  }): RestResponse<R>;
}

export class RestApplicationClient<O> {
  constructor(protected httpClient: HttpClient<O>) {}

  /**
   * HTTP POST /settlement/due-date-configuration/calculate-due-date
   * Java method: com.europoint.settlement.webapi.web.controllers.DueDateConfigurationController.calculateDueDate
   */
  calculateDueDate(
    dueDatesRequest: GetDueDatesRequestDto,
    options?: O
  ): RestResponse<WebResponseEntity<DueDatesResponseDto>> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/due-date-configuration/calculate-due-date`,
      data: dueDatesRequest,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/due-date-configuration/test
   * Java method: com.europoint.settlement.webapi.web.controllers.DueDateConfigurationController.test
   */
  test$GET$settlement_duedateconfiguration_test(options?: O): RestResponse<WebStringResponse> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/due-date-configuration/test`,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/master-data/country-exists
   * Java method: com.europoint.settlement.webapi.web.controllers.MasterDataController.countryExists
   */
  countryExists(
    queryParams: { countryCode: string; serviceCode: string },
    options?: O
  ): RestResponse<WebResponseEntity<boolean>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/master-data/country-exists`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/master-data/currency-exists
   * Java method: com.europoint.settlement.webapi.web.controllers.MasterDataController.currencyExists
   */
  currencyExists(
    queryParams: { currencyCode: string; serviceCode: string },
    options?: O
  ): RestResponse<WebResponseEntity<boolean>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/master-data/currency-exists`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/master-data/get-all-agent-accounts-by-agent
   * Java method: com.europoint.settlement.webapi.web.controllers.MasterDataController.getAllAgentAccountsByAgentId
   */
  getAllAgentAccountsByAgentId(
    queryParams: { agentId: string },
    options?: O
  ): RestResponse<WebListResponseEntity<AgentAccountCommonDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/master-data/get-all-agent-accounts-by-agent`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/master-data/get-all-agent-assoc-services-by-agent
   * Java method: com.europoint.settlement.webapi.web.controllers.MasterDataController.getAllAgentAssocServicesByAgentId
   */
  getAllAgentAssocServicesByAgentId(
    queryParams: { agentId: string },
    options?: O
  ): RestResponse<WebListResponseEntity<AgentAssocServiceCommonDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/master-data/get-all-agent-assoc-services-by-agent`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/master-data/get-all-agents
   * Java method: com.europoint.settlement.webapi.web.controllers.MasterDataController.getAllAgents
   */
  getAllAgents(options?: O): RestResponse<WebListResponseEntity<AgentCommonDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/master-data/get-all-agents`,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/master-data/get-all-master-agent-accounts
   * Java method: com.europoint.settlement.webapi.web.controllers.MasterDataController.getAllMasterAgentAccounts
   */
  getAllMasterAgentAccounts(
    options?: O
  ): RestResponse<WebListResponseEntity<MasterAgentAccountCommonDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/master-data/get-all-master-agent-accounts`,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/master-data/get-all-platform-services
   * Java method: com.europoint.settlement.webapi.web.controllers.MasterDataController.getAllPlatformServices
   */
  getAllPlatformServices(
    options?: O
  ): RestResponse<WebListResponseEntity<SettlementPlatformServiceCommonDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/master-data/get-all-platform-services`,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/master-data/get-all-platform-sub-services
   * Java method: com.europoint.settlement.webapi.web.controllers.MasterDataController.getAllPlatformSubServices
   */
  getAllPlatformSubServices(
    options?: O
  ): RestResponse<WebListResponseEntity<SettlementPlatformSubServiceCommonDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/master-data/get-all-platform-sub-services`,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/master-data/get-master-agent
   * Java method: com.europoint.settlement.webapi.web.controllers.MasterDataController.getMasterAgent
   */
  getMasterAgent(options?: O): RestResponse<WebResponseEntity<MasterAgentCommonDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/master-data/get-master-agent`,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/master-data/get-platform-service
   * Java method: com.europoint.settlement.webapi.web.controllers.MasterDataController.getPlatformService
   */
  getPlatformService(
    queryParams: { platformServiceId: string },
    options?: O
  ): RestResponse<WebResponseEntity<SettlementPlatformServiceCommonDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/master-data/get-platform-service`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/master-data/get-service-countries
   * Java method: com.europoint.settlement.webapi.web.controllers.MasterDataController.getCountries
   */
  getCountries(
    queryParams?: { serviceCode?: string },
    options?: O
  ): RestResponse<WebListResponseEntity<ServiceCountry>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/master-data/get-service-countries`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/master-data/get-service-currencies
   * Java method: com.europoint.settlement.webapi.web.controllers.MasterDataController.getCurrencies
   */
  getCurrencies(
    queryParams?: { serviceCode?: string },
    options?: O
  ): RestResponse<WebListResponseEntity<ServiceCurrency>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/master-data/get-service-currencies`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/master-data/get-service-provider-info
   * Java method: com.europoint.settlement.webapi.web.controllers.MasterDataController.getServiceProviderInfo
   */
  getServiceProviderInfo(
    queryParams: { serviceCode: string },
    options?: O
  ): RestResponse<WebResponseEntity<ServiceProviderInfo>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/master-data/get-service-provider-info`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/received-payment/create
   * Java method: com.europoint.settlement.webapi.web.controllers.ReceivedPaymentController.createReceivedPayment
   */
  createReceivedPayment(
    createReceivedPaymentRequest: CreateReceivedPaymentDto,
    options?: O
  ): RestResponse<WebResponseEntity<ReceivedPaymentCommonDto>> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/received-payment/create`,
      data: createReceivedPaymentRequest,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/received-payment/get-all
   * Java method: com.europoint.settlement.webapi.web.controllers.ReceivedPaymentController.getAllReceivedPayments
   */
  getAllReceivedPayments(
    options?: O
  ): RestResponse<WebListResponseEntity<ReceivedPaymentCommonDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/received-payment/get-all`,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/received-payment/get-all-by-agent
   * Java method: com.europoint.settlement.webapi.web.controllers.ReceivedPaymentController.getAllReceivedPaymentsByAgentId
   */
  getAllReceivedPaymentsByAgentId(
    queryParams: { agentId: string },
    options?: O
  ): RestResponse<WebListResponseEntity<ReceivedPaymentCommonDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/received-payment/get-all-by-agent`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/received-payment/get-all-to-agent
   * Java method: com.europoint.settlement.webapi.web.controllers.ReceivedPaymentController.getAllReceivedPaymentsToAgentId
   */
  getAllReceivedPaymentsToAgentId(
    queryParams: { agentId: string },
    options?: O
  ): RestResponse<WebListResponseEntity<ReceivedPaymentCommonDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/received-payment/get-all-to-agent`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/received-payment/get-by-id
   * Java method: com.europoint.settlement.webapi.web.controllers.ReceivedPaymentController.getReceivedPaymentById
   */
  getReceivedPaymentById(
    queryParams: { id: string },
    options?: O
  ): RestResponse<WebResponseEntity<ReceivedPaymentCommonDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/received-payment/get-by-id`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/received-payment/test
   * Java method: com.europoint.settlement.webapi.web.controllers.ReceivedPaymentController.test
   */
  test$GET$settlement_receivedpayment_test(options?: O): RestResponse<WebStringResponse> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/received-payment/test`,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/settlement-calculation/emergency-settlement-for-agent
   * Java method: com.europoint.settlement.webapi.web.controllers.SettlementCalculationController.emergencySettlementForAgent
   */
  emergencySettlementForAgent(
    queryParams: { agentId: string; masterAgentId: string },
    options?: O
  ): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/settlement-calculation/emergency-settlement-for-agent`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/settlement-calculation/finish-upward-settlement
   * Java method: com.europoint.settlement.webapi.web.controllers.SettlementCalculationController.finishUpwardSettlement
   */
  finishUpwardSettlement(
    queryParams: {
      dueDate: DateAsString;
      serviceProviderId: number;
      serviceId: string;
      settlementAmount: number;
    },
    options?: O
  ): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/settlement-calculation/finish-upward-settlement`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/settlement-calculation/get-all-new-settlement-transactions-by-agent
   * Java method: com.europoint.settlement.webapi.web.controllers.SettlementCalculationController.getNewSettlementTransactionsByAgent
   */
  getNewSettlementTransactionsByAgent(
    queryParams: { agentId: string },
    options?: O
  ): RestResponse<WebListResponseEntity<SettlementTransactionCommonDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/settlement-calculation/get-all-new-settlement-transactions-by-agent`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/settlement-calculation/get-all-opened-pending-business-transactions
   * Java method: com.europoint.settlement.webapi.web.controllers.SettlementCalculationController.getAllOpenedPendingBusinessTransactions
   */
  getAllOpenedPendingBusinessTransactions(
    options?: O
  ): RestResponse<WebListResponseEntity<PendingBusinessTransactionCommonDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/settlement-calculation/get-all-opened-pending-business-transactions`,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/settlement-calculation/get-all-settlement-entries-by-order-entry-id
   * Java method: com.europoint.settlement.webapi.web.controllers.SettlementCalculationController.getAllSettlementEntriesByOrderEntryId
   */
  getAllSettlementEntriesByOrderEntryId(
    queryParams: { orderEntryId: string },
    options?: O
  ): RestResponse<WebListResponseEntity<SettlementEntryCommonDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/settlement-calculation/get-all-settlement-entries-by-order-entry-id`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/settlement-calculation/get-all-settlement-entries-by-settlement-id
   * Java method: com.europoint.settlement.webapi.web.controllers.SettlementCalculationController.getAllSettlementEntriesBySettlementId
   */
  getAllSettlementEntriesBySettlementId(
    queryParams: { settlementId: string },
    options?: O
  ): RestResponse<WebListResponseEntity<SettlementEntryCommonDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/settlement-calculation/get-all-settlement-entries-by-settlement-id`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/settlement-calculation/get-all-settlement-order-entries-by-order-id
   * Java method: com.europoint.settlement.webapi.web.controllers.SettlementCalculationController.getAllSettlementOrderEntriesByOrderId
   */
  getAllSettlementOrderEntriesByOrderId(
    queryParams: { orderId: string },
    options?: O
  ): RestResponse<WebListResponseEntity<SettlementOrderEntryCommonDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/settlement-calculation/get-all-settlement-order-entries-by-order-id`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/settlement-calculation/get-all-settlement-orders-by-date
   * Java method: com.europoint.settlement.webapi.web.controllers.SettlementCalculationController.getAllSettlementOrdersByDate
   */
  getAllSettlementOrdersByDate(
    queryParams: { settlementOrderDate: DateAsString },
    options?: O
  ): RestResponse<WebListResponseEntity<SettlementOrderCommonDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/settlement-calculation/get-all-settlement-orders-by-date`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/settlement-calculation/get-all-settlement-transactions-by-agent
   * Java method: com.europoint.settlement.webapi.web.controllers.SettlementCalculationController.getAllSettlementTransactionsByAgent
   */
  getAllSettlementTransactionsByAgent(
    queryParams: { agentId: string },
    options?: O
  ): RestResponse<WebListResponseEntity<SettlementTransactionCommonDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/settlement-calculation/get-all-settlement-transactions-by-agent`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/settlement-calculation/get-settlement-transactions-for-risk-by-agent
   * Java method: com.europoint.settlement.webapi.web.controllers.SettlementCalculationController.getSettlementTransactionsForRiskByAgent
   */
  getSettlementTransactionsForRiskByAgent(
    queryParams: { agentId: string },
    options?: O
  ): RestResponse<WebListResponseEntity<SettlementTransactionCommonDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/settlement-calculation/get-settlement-transactions-for-risk-by-agent`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/settlement-calculation/get-settlements-by-agent
   * Java method: com.europoint.settlement.webapi.web.controllers.SettlementCalculationController.getSettlementByAgent
   */
  getSettlementByAgent(
    queryParams: { agentId: string },
    options?: O
  ): RestResponse<WebListResponseEntity<SettlementCommonDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/settlement-calculation/get-settlements-by-agent`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/settlement-calculation/payment-settlement-for-agent
   * Java method: com.europoint.settlement.webapi.web.controllers.SettlementCalculationController.paymentSettlementForAgent
   */
  paymentSettlementForAgent(
    queryParams: { agentId: string },
    options?: O
  ): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/settlement-calculation/payment-settlement-for-agent`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/settlement-calculation/resolve-agent-debt-risks
   * Java method: com.europoint.settlement.webapi.web.controllers.SettlementCalculationController.resolveAgentDebtRisks
   */
  resolveAgentDebtRisks(
    queryParams: { agentId: string },
    options?: O
  ): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/settlement-calculation/resolve-agent-debt-risks`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/settlement-calculation/retry-pending-business-transaction
   * Java method: com.europoint.settlement.webapi.web.controllers.SettlementCalculationController.retryPendingBusinessTransaction
   */
  retryPendingBusinessTransaction(
    queryParams: { pendingBusinessTransactionId: string },
    options?: O
  ): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/settlement-calculation/retry-pending-business-transaction`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/settlement-calculation/retry-pending-business-transactions
   * Java method: com.europoint.settlement.webapi.web.controllers.SettlementCalculationController.retryAllPendingBusinessTransactions
   */
  retryAllPendingBusinessTransactions(options?: O): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/settlement-calculation/retry-pending-business-transactions`,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/settlement-calculation/search-settlement-transactions
   * Java method: com.europoint.settlement.webapi.web.controllers.SettlementCalculationController.searchSettlementTransactions
   */
  searchSettlementTransactions(
    request: SearchRequest,
    options?: O
  ): RestResponse<Page<SettlementTransactionCommonDto>> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/settlement-calculation/search-settlement-transactions`,
      data: request,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/settlement-calculation/start-upward-settlement
   * Java method: com.europoint.settlement.webapi.web.controllers.SettlementCalculationController.startUpwardSettlement
   */
  startUpwardSettlement(
    queryParams: { dueDate: DateAsString; serviceProviderId: number; serviceId: string },
    options?: O
  ): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/settlement-calculation/start-upward-settlement`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/settlement-calculation/test
   * Java method: com.europoint.settlement.webapi.web.controllers.SettlementCalculationController.test
   */
  test$GET$settlement_settlementcalculation_test(options?: O): RestResponse<WebStringResponse> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/settlement-calculation/test`,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/settlement-configuration/activate
   * Java method: com.europoint.settlement.webapi.web.controllers.SettlementConfigurationController.activate
   */
  activate(
    queryParams: { settlementConfigurationId: string },
    options?: O
  ): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/settlement-configuration/activate`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/settlement-configuration/create
   * Java method: com.europoint.settlement.webapi.web.controllers.SettlementConfigurationController.create
   */
  create$POST$settlement_settlementconfiguration_create(
    createSettlementConfigurationRequest: CreateSettlementConfigurationDto,
    options?: O
  ): RestResponse<WebResponseEntity<SettlementConfigurationCommonDto>> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/settlement-configuration/create`,
      data: createSettlementConfigurationRequest,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/settlement-configuration/deactivate
   * Java method: com.europoint.settlement.webapi.web.controllers.SettlementConfigurationController.deactivate
   */
  deactivate(
    queryParams: { settlementConfigurationId: string },
    options?: O
  ): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/settlement-configuration/deactivate`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/settlement-configuration/delete
   * Java method: com.europoint.settlement.webapi.web.controllers.SettlementConfigurationController.delete
   */
  delete(
    queryParams: { settlementConfigurationId: string },
    options?: O
  ): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/settlement-configuration/delete`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/settlement-configuration/edit
   * Java method: com.europoint.settlement.webapi.web.controllers.SettlementConfigurationController.edit
   */
  edit(
    queryParams: { settlementConfigurationId: string },
    options?: O
  ): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/settlement-configuration/edit`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/settlement-configuration/finish
   * Java method: com.europoint.settlement.webapi.web.controllers.SettlementConfigurationController.finish
   */
  finish(
    queryParams: { settlementConfigurationId: string },
    options?: O
  ): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/settlement-configuration/finish`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/settlement-configuration/get
   * Java method: com.europoint.settlement.webapi.web.controllers.SettlementConfigurationController.get
   */
  get(
    queryParams: { settlementConfigurationId: string },
    options?: O
  ): RestResponse<WebResponseEntity<SettlementConfigurationCommonDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/settlement-configuration/get`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/settlement-configuration/get-active-by-agent
   * Java method: com.europoint.settlement.webapi.web.controllers.SettlementConfigurationController.getActiveByAgentId
   */
  getActiveByAgentId(
    queryParams: { agentId: string },
    options?: O
  ): RestResponse<WebResponseEntity<SettlementConfigurationCommonDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/settlement-configuration/get-active-by-agent`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/settlement-configuration/get-by-agent
   * Java method: com.europoint.settlement.webapi.web.controllers.SettlementConfigurationController.getByAgentId
   */
  getByAgentId(
    queryParams: { agentId: string },
    options?: O
  ): RestResponse<WebListResponseEntity<SettlementConfigurationCommonDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/settlement-configuration/get-by-agent`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/settlement-configuration/get-template
   * Java method: com.europoint.settlement.webapi.web.controllers.SettlementConfigurationController.getTemplate
   */
  getTemplate(
    queryParams: { settlementTemplateId: string },
    options?: O
  ): RestResponse<WebResponseEntity<SettlementConfigurationTemplateDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/settlement-configuration/get-template`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/settlement-configuration/save-template
   * Java method: com.europoint.settlement.webapi.web.controllers.SettlementConfigurationController.saveTemplate
   */
  saveTemplate(
    queryParams: { settlementConfigurationId: string },
    options?: O
  ): RestResponse<WebUUIDResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/settlement-configuration/save-template`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/settlement-configuration/test
   * Java method: com.europoint.settlement.webapi.web.controllers.SettlementConfigurationController.test
   */
  test$GET$settlement_settlementconfiguration_test(options?: O): RestResponse<WebStringResponse> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/settlement-configuration/test`,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/settlement-configuration/update
   * Java method: com.europoint.settlement.webapi.web.controllers.SettlementConfigurationController.update
   */
  update$POST$settlement_settlementconfiguration_update(
    updateSettlementConfigurationDto: UpdateSettlementConfigurationDto,
    options?: O
  ): RestResponse<WebResponseEntity<SettlementConfigurationCommonDto>> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/settlement-configuration/update`,
      data: updateSettlementConfigurationDto,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/sharing-arrangement-model/activate
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementModelController.activateModel
   */
  activateModel(activateDto: ActivateDto, options?: O): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/sharing-arrangement-model/activate`,
      data: activateDto,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/sharing-arrangement-model/close
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementModelController.closeModel
   */
  closeModel(closeDto: CloseDto, options?: O): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/sharing-arrangement-model/close`,
      data: closeDto,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/sharing-arrangement-model/create
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementModelController.createSharingArrangementModel
   */
  createSharingArrangementModel(
    createModelDto: CreateSharingArrangementModelDto,
    options?: O
  ): RestResponse<WebResponseEntity<SharingArrangementModelCommonDto>> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/sharing-arrangement-model/create`,
      data: createModelDto,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/sharing-arrangement-model/deactivate
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementModelController.deactivateModel
   */
  deactivateModel(deactivateDto: DeactivateDto, options?: O): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/sharing-arrangement-model/deactivate`,
      data: deactivateDto,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/sharing-arrangement-model/delete
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementModelController.deleteModel
   */
  deleteModel(queryParams: { id: string }, options?: O): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/sharing-arrangement-model/delete`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/sharing-arrangement-model/delete-items
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementModelController.deleteModelItems
   */
  deleteModelItems(
    deleteModelItemsDto: DeleteSharingArrangementModelItemsDto,
    options?: O
  ): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/sharing-arrangement-model/delete-items`,
      data: deleteModelItemsDto,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/sharing-arrangement-model/finish-creating
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementModelController.finishCreatingModel
   */
  finishCreatingModel(
    finishCreatingDto: FinishCreatingDto,
    options?: O
  ): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/sharing-arrangement-model/finish-creating`,
      data: finishCreatingDto,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/sharing-arrangement-model/finish-forming
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementModelController.finishFormingModel
   */
  finishFormingModel(
    finishFormingDto: FinishFormingDto,
    options?: O
  ): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/sharing-arrangement-model/finish-forming`,
      data: finishFormingDto,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/sharing-arrangement-model/finish-parametrizing
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementModelController.finishParametrizingModel
   */
  finishParametrizingModel(
    finishParametrizingDto: FinishParametrizingDto,
    options?: O
  ): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/sharing-arrangement-model/finish-parametrizing`,
      data: finishParametrizingDto,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/sharing-arrangement-model/get-all
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementModelController.getAllModels
   */
  getAllModels(options?: O): RestResponse<WebListResponseEntity<SharingArrangementModelCommonDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/sharing-arrangement-model/get-all`,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/sharing-arrangement-model/get-all-active
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementModelController.getActiveModels
   */
  getActiveModels(
    options?: O
  ): RestResponse<WebListResponseEntity<SharingArrangementModelCommonDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/sharing-arrangement-model/get-all-active`,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/sharing-arrangement-model/get-all-by-platform-service
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementModelController.getAllModelsByPlatformServiceId
   */
  getAllModelsByPlatformServiceId(
    queryParams: { platformServiceId: string },
    options?: O
  ): RestResponse<WebListResponseEntity<SharingArrangementModelCommonDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/sharing-arrangement-model/get-all-by-platform-service`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/sharing-arrangement-model/get-by-id
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementModelController.getModelById
   */
  getModelById(
    queryParams: { id: string },
    options?: O
  ): RestResponse<WebResponseEntity<SharingArrangementModelCommonDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/sharing-arrangement-model/get-by-id`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/sharing-arrangement-model/get-service-provider-model-by-platform-service
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementModelController.getServiceProviderModelByPlatformServiceId
   */
  getServiceProviderModelByPlatformServiceId(
    queryParams: { platformServiceId: string },
    options?: O
  ): RestResponse<WebResponseEntity<SharingArrangementModelCommonDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/sharing-arrangement-model/get-service-provider-model-by-platform-service`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/sharing-arrangement-model/reject
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementModelController.rejectModel
   */
  rejectModel(rejectDto: RejectDto, options?: O): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/sharing-arrangement-model/reject`,
      data: rejectDto,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/sharing-arrangement-model/request-deactivation
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementModelController.requestModelDeactivation
   */
  requestModelDeactivation(
    requestDeactivationDto: RequestDeactivationDto,
    options?: O
  ): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/sharing-arrangement-model/request-deactivation`,
      data: requestDeactivationDto,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/sharing-arrangement-model/return-for-update
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementModelController.returnModelForUpdate
   */
  returnModelForUpdate(
    returnForUpdateDto: ReturnForUpdateDto,
    options?: O
  ): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/sharing-arrangement-model/return-for-update`,
      data: returnForUpdateDto,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/sharing-arrangement-model/search
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementModelController.searchAllModels
   */
  searchAllModels(
    request: SearchRequest,
    options?: O
  ): RestResponse<Page<SharingArrangementModelCommonDto>> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/sharing-arrangement-model/search`,
      data: request,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/sharing-arrangement-model/soft-delete
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementModelController.softDeleteModel
   */
  softDeleteModel(softDeleteDto: SoftDeleteDto, options?: O): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/sharing-arrangement-model/soft-delete`,
      data: softDeleteDto,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/sharing-arrangement-model/test
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementModelController.test
   */
  test$GET$settlement_sharingarrangementmodel_test(options?: O): RestResponse<WebStringResponse> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/sharing-arrangement-model/test`,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/sharing-arrangement-model/update
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementModelController.updateSharingArrangementModel
   */
  updateSharingArrangementModel(
    updateModelDto: UpdateSharingArrangementModelDto,
    options?: O
  ): RestResponse<WebResponseEntity<SharingArrangementModelCommonDto>> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/sharing-arrangement-model/update`,
      data: updateModelDto,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/sharing-arrangement-model/update-criteria
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementModelController.updateModelCriteria
   */
  updateModelCriteria(
    updateModelCriterionDto: UpdateSharingArrangementCriterionDto,
    options?: O
  ): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/sharing-arrangement-model/update-criteria`,
      data: updateModelCriterionDto,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/sharing-arrangement-model/update-items
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementModelController.updateModelItems
   */
  updateModelItems(
    updateModelItemsDto: UpdateSharingArrangementModelItemsDto,
    options?: O
  ): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/sharing-arrangement-model/update-items`,
      data: updateModelItemsDto,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/sharing-arrangement-model/verify
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementModelController.verifyModel
   */
  verifyModel(verifyDto: VerifyDto, options?: O): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/sharing-arrangement-model/verify`,
      data: verifyDto,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/sharing-arrangement-parameter/create
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementParameterController.createParameter
   */
  createParameter(
    createSharingArrangementParameterDto: CreateSharingArrangementParameterDto,
    options?: O
  ): RestResponse<WebResponseEntity<SharingArrangementParameterCommonDto>> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/sharing-arrangement-parameter/create`,
      data: createSharingArrangementParameterDto,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/sharing-arrangement-parameter/delete
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementParameterController.deleteParameter
   */
  deleteParameter(queryParams: { id: string }, options?: O): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/sharing-arrangement-parameter/delete`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/sharing-arrangement-parameter/get-all
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementParameterController.getAllParameters
   */
  getAllParameters(
    options?: O
  ): RestResponse<WebListResponseEntity<SharingArrangementParameterCommonDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/sharing-arrangement-parameter/get-all`,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/sharing-arrangement-parameter/get-all-by-platform-service
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementParameterController.getAllByPlatformServiceId
   */
  getAllByPlatformServiceId(
    queryParams: { platformServiceId: string },
    options?: O
  ): RestResponse<WebListResponseEntity<SharingArrangementParameterCommonDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/sharing-arrangement-parameter/get-all-by-platform-service`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/sharing-arrangement-parameter/get-by-id
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementParameterController.getParameterById
   */
  getParameterById(
    queryParams: { id: string },
    options?: O
  ): RestResponse<WebResponseEntity<SharingArrangementParameterCommonDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/sharing-arrangement-parameter/get-by-id`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/sharing-arrangement-parameter/test
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementParameterController.test
   */
  test$GET$settlement_sharingarrangementparameter_test(
    options?: O
  ): RestResponse<WebStringResponse> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/sharing-arrangement-parameter/test`,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/sharing-arrangement-parameter/update
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementParameterController.updateParameter
   */
  updateParameter(
    updateParameterDto: UpdateSharingArrangementParameterDto,
    options?: O
  ): RestResponse<WebResponseEntity<SharingArrangementParameterCommonDto>> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/sharing-arrangement-parameter/update`,
      data: updateParameterDto,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/sharing-arrangement-service-provider/activate
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementServiceProviderController.activateSharingArrangement
   */
  activateSharingArrangement$POST$settlement_sharingarrangementserviceprovider_activate(
    queryParams: { id: string },
    options?: O
  ): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/sharing-arrangement-service-provider/activate`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/sharing-arrangement-service-provider/create
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementServiceProviderController.createSharingArrangement
   */
  createSharingArrangement$POST$settlement_sharingarrangementserviceprovider_create(
    createSharingArrangementDto: CreateSharingArrangementServiceProviderDto,
    options?: O
  ): RestResponse<WebResponseEntity<SharingArrangementServiceProviderCommonDto>> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/sharing-arrangement-service-provider/create`,
      data: createSharingArrangementDto,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/sharing-arrangement-service-provider/deactivate
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementServiceProviderController.deactivateSharingArrangement
   */
  deactivateSharingArrangement$POST$settlement_sharingarrangementserviceprovider_deactivate(
    queryParams: { id: string },
    options?: O
  ): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/sharing-arrangement-service-provider/deactivate`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/sharing-arrangement-service-provider/delete
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementServiceProviderController.deleteSharingArrangement
   */
  deleteSharingArrangement$POST$settlement_sharingarrangementserviceprovider_delete(
    queryParams: { id: string },
    options?: O
  ): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/sharing-arrangement-service-provider/delete`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/sharing-arrangement-service-provider/finish
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementServiceProviderController.finishSharingArrangement
   */
  finishSharingArrangement$POST$settlement_sharingarrangementserviceprovider_finish(
    queryParams: { id: string },
    options?: O
  ): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/sharing-arrangement-service-provider/finish`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/sharing-arrangement-service-provider/get-all
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementServiceProviderController.getAll
   */
  getAll$GET$settlement_sharingarrangementserviceprovider_getall(
    options?: O
  ): RestResponse<WebListResponseEntity<SharingArrangementServiceProviderCommonDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/sharing-arrangement-service-provider/get-all`,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/sharing-arrangement-service-provider/get-all-by-model-description
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementServiceProviderController.getAllByModelDescription
   */
  getAllByModelDescription$GET$settlement_sharingarrangementserviceprovider_getallbymodeldescription(
    queryParams: { sharingArrangementModelDescription: string },
    options?: O
  ): RestResponse<WebListResponseEntity<SharingArrangementServiceProviderCommonDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/sharing-arrangement-service-provider/get-all-by-model-description`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/sharing-arrangement-service-provider/get-all-by-model-id
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementServiceProviderController.getAllByModelId
   */
  getAllByModelId$GET$settlement_sharingarrangementserviceprovider_getallbymodelid(
    queryParams: { modelId: string },
    options?: O
  ): RestResponse<WebListResponseEntity<SharingArrangementServiceProviderCommonDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/sharing-arrangement-service-provider/get-all-by-model-id`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/sharing-arrangement-service-provider/get-all-by-model-name
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementServiceProviderController.getAllByModelName
   */
  getAllByModelName$GET$settlement_sharingarrangementserviceprovider_getallbymodelname(
    queryParams: { sharingArrangementModelName: string },
    options?: O
  ): RestResponse<WebListResponseEntity<SharingArrangementServiceProviderCommonDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/sharing-arrangement-service-provider/get-all-by-model-name`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/sharing-arrangement-service-provider/get-all-by-model-valid-from
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementServiceProviderController.getAllByValidFrom
   */
  getAllByValidFrom$GET$settlement_sharingarrangementserviceprovider_getallbymodelvalidfrom(
    queryParams: { validFromDateTime: DateAsString },
    options?: O
  ): RestResponse<WebListResponseEntity<SharingArrangementServiceProviderCommonDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/sharing-arrangement-service-provider/get-all-by-model-valid-from`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/sharing-arrangement-service-provider/get-by-id
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementServiceProviderController.getById
   */
  getById$GET$settlement_sharingarrangementserviceprovider_getbyid(
    queryParams: { id: string },
    options?: O
  ): RestResponse<WebResponseEntity<SharingArrangementServiceProviderCommonDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/sharing-arrangement-service-provider/get-by-id`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/sharing-arrangement-service-provider/search
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementServiceProviderController.searchAll
   */
  searchAll$POST$settlement_sharingarrangementserviceprovider_search(
    request: SearchRequest,
    options?: O
  ): RestResponse<Page<SharingArrangementServiceProviderCommonDto>> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/sharing-arrangement-service-provider/search`,
      data: request,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/sharing-arrangement-service-provider/test
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementServiceProviderController.test
   */
  test$GET$settlement_sharingarrangementserviceprovider_test(
    options?: O
  ): RestResponse<WebStringResponse> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/sharing-arrangement-service-provider/test`,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/sharing-arrangement-service-provider/update
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementServiceProviderController.updateSharingArrangement
   */
  updateSharingArrangement$POST$settlement_sharingarrangementserviceprovider_update(
    updateSharingArrangementDto: UpdateSharingArrangementServiceProviderDto,
    options?: O
  ): RestResponse<WebResponseEntity<SharingArrangementServiceProviderCommonDto>> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/sharing-arrangement-service-provider/update`,
      data: updateSharingArrangementDto,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/sharing-arrangement/activate
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementController.activateSharingArrangement
   */
  activateSharingArrangement$POST$settlement_sharingarrangement_activate(
    queryParams: { id: string },
    options?: O
  ): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/sharing-arrangement/activate`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/sharing-arrangement/create
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementController.createSharingArrangement
   */
  createSharingArrangement$POST$settlement_sharingarrangement_create(
    createSharingArrangementDto: CreateSharingArrangementDto,
    options?: O
  ): RestResponse<WebResponseEntity<SharingArrangementCommonDto>> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/sharing-arrangement/create`,
      data: createSharingArrangementDto,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/sharing-arrangement/deactivate
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementController.deactivateSharingArrangement
   */
  deactivateSharingArrangement$POST$settlement_sharingarrangement_deactivate(
    queryParams: { id: string },
    options?: O
  ): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/sharing-arrangement/deactivate`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/sharing-arrangement/delete
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementController.deleteSharingArrangement
   */
  deleteSharingArrangement$POST$settlement_sharingarrangement_delete(
    queryParams: { id: string },
    options?: O
  ): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/sharing-arrangement/delete`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/sharing-arrangement/finish
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementController.finishSharingArrangement
   */
  finishSharingArrangement$POST$settlement_sharingarrangement_finish(
    queryParams: { id: string },
    options?: O
  ): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/sharing-arrangement/finish`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/sharing-arrangement/get-all-by-model-description
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementController.getAllByModelDescription
   */
  getAllByModelDescription$GET$settlement_sharingarrangement_getallbymodeldescription(
    queryParams: { sharingArrangementModelDescription: string },
    options?: O
  ): RestResponse<WebListResponseEntity<SharingArrangementCommonDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/sharing-arrangement/get-all-by-model-description`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/sharing-arrangement/get-all-by-model-id
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementController.getAllByModelId
   */
  getAllByModelId$GET$settlement_sharingarrangement_getallbymodelid(
    queryParams: { modelId: string },
    options?: O
  ): RestResponse<WebListResponseEntity<SharingArrangementCommonDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/sharing-arrangement/get-all-by-model-id`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/sharing-arrangement/get-all-by-model-name
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementController.getAllByModelName
   */
  getAllByModelName$GET$settlement_sharingarrangement_getallbymodelname(
    queryParams: { sharingArrangementModelName: string },
    options?: O
  ): RestResponse<WebListResponseEntity<SharingArrangementCommonDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/sharing-arrangement/get-all-by-model-name`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/sharing-arrangement/get-all-by-valid-from
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementController.getAllByValidFrom
   */
  getAllByValidFrom$GET$settlement_sharingarrangement_getallbyvalidfrom(
    queryParams: { validFromDateTime: DateAsString },
    options?: O
  ): RestResponse<WebListResponseEntity<SharingArrangementCommonDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/sharing-arrangement/get-all-by-valid-from`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/sharing-arrangement/get-by-id
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementController.getById
   */
  getById$GET$settlement_sharingarrangement_getbyid(
    queryParams: { id: string },
    options?: O
  ): RestResponse<WebResponseEntity<SharingArrangementCommonDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/sharing-arrangement/get-by-id`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/sharing-arrangement/getAll
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementController.getAll
   */
  getAll$GET$settlement_sharingarrangement_getAll(
    options?: O
  ): RestResponse<WebListResponseEntity<SharingArrangementCommonDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/sharing-arrangement/getAll`,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/sharing-arrangement/searchAll
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementController.searchAll
   */
  searchAll$POST$settlement_sharingarrangement_searchAll(
    request: SearchRequest,
    options?: O
  ): RestResponse<Page<SharingArrangementCommonDto>> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/sharing-arrangement/searchAll`,
      data: request,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/sharing-arrangement/test
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementController.test
   */
  test$GET$settlement_sharingarrangement_test(options?: O): RestResponse<WebStringResponse> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/sharing-arrangement/test`,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/sharing-arrangement/update
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingArrangementController.updateSharingArrangement
   */
  updateSharingArrangement$POST$settlement_sharingarrangement_update(
    updateSharingArrangementDto: UpdateSharingArrangementDto,
    options?: O
  ): RestResponse<WebResponseEntity<SharingArrangementCommonDto>> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/sharing-arrangement/update`,
      data: updateSharingArrangementDto,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/sharing/create-test-transaction
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingController.createTestTransaction
   */
  createTestTransaction(
    businessTransactionInfo: BusinessTransactionInfo,
    options?: O
  ): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/sharing/create-test-transaction`,
      data: businessTransactionInfo,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/sharing/fetch-json/{fileName:.+}
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingController.fetchJson
   */
  fetchJson(fileName: string, options?: O): RestResponse<string> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/sharing/fetch-json/${fileName}`,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/sharing/get-share
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingController.getShare
   */
  getShare(
    sharingRequest: PaymentOrderRequestCommissionRequest,
    options?: O
  ): RestResponse<WebResponseEntity<CommissionResultResponse>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/sharing/get-share`,
      data: sharingRequest,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/sharing/import-test-transactions
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingController.importTestTransactions
   */
  importTestTransactions(options?: O): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/sharing/import-test-transactions`,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/sharing/test
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingController.test
   */
  test$GET$settlement_sharing_test(options?: O): RestResponse<WebStringResponse> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/sharing/test`,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/sharing/test-big-decimal
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingController.testBigDecimal
   */
  testBigDecimal(options?: O): RestResponse<WebStringResponse> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/sharing/test-big-decimal`,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/sharing/test-command
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingController.testCommand
   */
  testCommand(options?: O): RestResponse<WebStringResponse> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/sharing/test-command`,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/sharing/test-config
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingController.testConfig
   */
  testConfig(options?: O): RestResponse<WebListResponseEntity<string>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/sharing/test-config`,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/sharing/test-date-time
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingController.testInstant
   */
  testInstant(options?: O): RestResponse<WebStringResponse> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/sharing/test-date-time`,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/sharing/test-event
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingController.testEvent
   */
  testEvent(options?: O): RestResponse<WebStringResponse> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/sharing/test-event`,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/sharing/test-tenant-provider
   * Java method: com.europoint.settlement.webapi.web.controllers.SharingController.testTenantProvider
   */
  testTenantProvider(options?: O): RestResponse<WebStringResponse> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/sharing/test-tenant-provider`,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/western-union-code-book/create-adjustment-reason-code
   * Java method: com.europoint.settlement.webapi.web.controllers.WesternUnionCodeBookController.createAdjustmentReasonCode
   */
  createAdjustmentReasonCode(
    request: AdjustmentReasonCodeDto,
    options?: O
  ): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/western-union-code-book/create-adjustment-reason-code`,
      data: request,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/western-union-code-book/create-record-type
   * Java method: com.europoint.settlement.webapi.web.controllers.WesternUnionCodeBookController.createRecordType
   */
  createRecordType(request: RecordTypeDto, options?: O): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/western-union-code-book/create-record-type`,
      data: request,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/western-union-code-book/delete-adjustment-reason-code
   * Java method: com.europoint.settlement.webapi.web.controllers.WesternUnionCodeBookController.deleteAdjustmentReasonCode
   */
  deleteAdjustmentReasonCode(
    request: AdjustmentReasonCodeDto,
    options?: O
  ): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/western-union-code-book/delete-adjustment-reason-code`,
      data: request,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/western-union-code-book/delete-record-type
   * Java method: com.europoint.settlement.webapi.web.controllers.WesternUnionCodeBookController.deleteRecordType
   */
  deleteRecordType(request: RecordTypeDto, options?: O): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/western-union-code-book/delete-record-type`,
      data: request,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/western-union-code-book/get-all-adjustment-reason-code
   * Java method: com.europoint.settlement.webapi.web.controllers.WesternUnionCodeBookController.getAllAdjustmentReasonCode
   */
  getAllAdjustmentReasonCode(
    options?: O
  ): RestResponse<WebListResponseEntity<AdjustmentReasonCodeDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/western-union-code-book/get-all-adjustment-reason-code`,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/western-union-code-book/get-all-record-type
   * Java method: com.europoint.settlement.webapi.web.controllers.WesternUnionCodeBookController.getAllRecordType
   */
  getAllRecordType(options?: O): RestResponse<WebListResponseEntity<RecordTypeDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/western-union-code-book/get-all-record-type`,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/western-union-code-book/import-adjustment-reason-code
   * Java method: com.europoint.settlement.webapi.web.controllers.WesternUnionCodeBookController.importAdjustmentReasonCode
   */
  importAdjustmentReasonCode(
    request: AdjustmentReasonCodeDto[],
    options?: O
  ): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/western-union-code-book/import-adjustment-reason-code`,
      data: request,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/western-union-code-book/update-adjustment-reason-code
   * Java method: com.europoint.settlement.webapi.web.controllers.WesternUnionCodeBookController.updateAdjustmentReasonCode
   */
  updateAdjustmentReasonCode(
    request: AdjustmentReasonCodeDto,
    options?: O
  ): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/western-union-code-book/update-adjustment-reason-code`,
      data: request,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/western-union-code-book/update-record-type
   * Java method: com.europoint.settlement.webapi.web.controllers.WesternUnionCodeBookController.updateRecordType
   */
  updateRecordType(request: RecordTypeDto, options?: O): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/western-union-code-book/update-record-type`,
      data: request,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/western-union-import/activity-file-upload
   * Java method: com.europoint.settlement.webapi.web.controllers.WesternUnionImportController.activityFileUpload
   */
  activityFileUpload(
    fileUploadRequest: FileUploadRequest,
    options?: O
  ): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/western-union-import/activity-file-upload`,
      data: fileUploadRequest,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/western-union-import/get-activity-data-payout-by-id
   * Java method: com.europoint.settlement.webapi.web.controllers.WesternUnionImportController.getActivityPayoutById
   */
  getActivityPayoutById(
    queryParams: { id: string },
    options?: O
  ): RestResponse<WebResponseEntity<WesternUnionActivityDataPayoutDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/western-union-import/get-activity-data-payout-by-id`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/western-union-import/get-activity-data-payout-by-mtcn
   * Java method: com.europoint.settlement.webapi.web.controllers.WesternUnionImportController.getActivityPayoutByMtcn
   */
  getActivityPayoutByMtcn(
    queryParams: { mtcn: number },
    options?: O
  ): RestResponse<WebListResponseEntity<WesternUnionActivityDataPayoutDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/western-union-import/get-activity-data-payout-by-mtcn`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/western-union-import/get-activity-data-send-by-id
   * Java method: com.europoint.settlement.webapi.web.controllers.WesternUnionImportController.getActivitySendById
   */
  getActivitySendById(
    queryParams: { id: string },
    options?: O
  ): RestResponse<WebResponseEntity<WesternUnionActivityDataSendDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/western-union-import/get-activity-data-send-by-id`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/western-union-import/get-activity-data-send-by-mtcn
   * Java method: com.europoint.settlement.webapi.web.controllers.WesternUnionImportController.getActivitySendByMtcn
   */
  getActivitySendByMtcn(
    queryParams: { mtcn: number },
    options?: O
  ): RestResponse<WebListResponseEntity<WesternUnionActivityDataSendDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/western-union-import/get-activity-data-send-by-mtcn`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/western-union-import/get-activity-payout-list
   * Java method: com.europoint.settlement.webapi.web.controllers.WesternUnionImportController.getActivityPayoutList
   */
  getActivityPayoutList(
    queryParams: { activityDataHeaderId: string },
    options?: O
  ): RestResponse<WebListResponseEntity<WesternUnionActivityShortDataPayoutDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/western-union-import/get-activity-payout-list`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/western-union-import/get-activity-send-list
   * Java method: com.europoint.settlement.webapi.web.controllers.WesternUnionImportController.getActivitySendList
   */
  getActivitySendList(
    queryParams: { activityDataHeaderId: string },
    options?: O
  ): RestResponse<WebListResponseEntity<WesternUnionActivityShortDataSendDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/western-union-import/get-activity-send-list`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/western-union-import/get-settlement-data-by-id
   * Java method: com.europoint.settlement.webapi.web.controllers.WesternUnionImportController.getSettlementDataById
   */
  getSettlementDataById(
    queryParams: { id: string },
    options?: O
  ): RestResponse<WebResponseEntity<WesternUnionSettlementDataDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/western-union-import/get-settlement-data-by-id`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/western-union-import/get-settlement-data-by-mtcn
   * Java method: com.europoint.settlement.webapi.web.controllers.WesternUnionImportController.getSettlementDataByMTCN
   */
  getSettlementDataByMTCN(
    queryParams: { mtcn: string },
    options?: O
  ): RestResponse<WebListResponseEntity<WesternUnionSettlementDataDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/western-union-import/get-settlement-data-by-mtcn`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/western-union-import/get-settlement-data-list
   * Java method: com.europoint.settlement.webapi.web.controllers.WesternUnionImportController.getSettlementDataList
   */
  getSettlementDataList(
    queryParams: { settlementDataHeaderId: string },
    options?: O
  ): RestResponse<WebListResponseEntity<WesternUnionSettlementShortDataDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/western-union-import/get-settlement-data-list`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/western-union-import/search-activity-headers
   * Java method: com.europoint.settlement.webapi.web.controllers.WesternUnionImportController.searchAllActivityHeaders
   */
  searchAllActivityHeaders(
    request: SearchRequest,
    options?: O
  ): RestResponse<Page<WesternUnionActivityDataHeaderDto>> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/western-union-import/search-activity-headers`,
      data: request,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/western-union-import/search-activity-payouts
   * Java method: com.europoint.settlement.webapi.web.controllers.WesternUnionImportController.searchAllActivityPayouts
   */
  searchAllActivityPayouts(
    request: SearchRequest,
    options?: O
  ): RestResponse<Page<WesternUnionActivityDataPayoutDto>> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/western-union-import/search-activity-payouts`,
      data: request,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/western-union-import/search-activity-sends
   * Java method: com.europoint.settlement.webapi.web.controllers.WesternUnionImportController.searchAllActivitySends
   */
  searchAllActivitySends(
    request: SearchRequest,
    options?: O
  ): RestResponse<Page<WesternUnionActivityDataSendDto>> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/western-union-import/search-activity-sends`,
      data: request,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/western-union-import/search-settlement-data
   * Java method: com.europoint.settlement.webapi.web.controllers.WesternUnionImportController.searchAllSettlementData
   */
  searchAllSettlementData(
    request: SearchRequest,
    options?: O
  ): RestResponse<Page<WesternUnionSettlementDataDto>> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/western-union-import/search-settlement-data`,
      data: request,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/western-union-import/search-settlement-headers
   * Java method: com.europoint.settlement.webapi.web.controllers.WesternUnionImportController.searchAllSettlementHeaders
   */
  searchAllSettlementHeaders(
    request: SearchRequest,
    options?: O
  ): RestResponse<Page<WesternUnionSettlementDataHeaderDto>> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/western-union-import/search-settlement-headers`,
      data: request,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/western-union-import/settlement-file-upload
   * Java method: com.europoint.settlement.webapi.web.controllers.WesternUnionImportController.settlementFileUpload
   */
  settlementFileUpload(
    fileUploadRequest: FileUploadRequest,
    options?: O
  ): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/western-union-import/settlement-file-upload`,
      data: fileUploadRequest,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/settlement-setting/add-master-agent-account
   * Java method: com.europoint.settlement.webapi.web.controllers.SettlementSettingController.addMasterAgentAccount
   */
  addMasterAgentAccount(
    requestDto: SettlementSettingAccountDto,
    options?: O
  ): RestResponse<WebResponseEntity<SettlementSettingDto>> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/settlement-setting/add-master-agent-account`,
      data: requestDto,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/settlement-setting/create
   * Java method: com.europoint.settlement.webapi.web.controllers.SettlementSettingController.create
   */
  create$POST$settlement_settlementsetting_create(
    settlementSettingDto: CreateSettlementSettingDto,
    options?: O
  ): RestResponse<WebResponseEntity<SettlementSettingDto>> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/settlement-setting/create`,
      data: settlementSettingDto,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/settlement-setting/get
   * Java method: com.europoint.settlement.webapi.web.controllers.SettlementSettingController.getSettlementSetting
   */
  getSettlementSetting(options?: O): RestResponse<WebResponseEntity<SettlementSettingDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/settlement-setting/get`,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/settlement-setting/get-by-id
   * Java method: com.europoint.settlement.webapi.web.controllers.SettlementSettingController.getById
   */
  getById$GET$settlement_settlementsetting_getbyid(
    queryParams: { settlementSettingId: string },
    options?: O
  ): RestResponse<WebResponseEntity<SettlementSettingDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/settlement-setting/get-by-id`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/settlement-setting/remove-master-agent-account
   * Java method: com.europoint.settlement.webapi.web.controllers.SettlementSettingController.removeMasterAgentAccount
   */
  removeMasterAgentAccount(
    requestDto: SettlementSettingAccountDto,
    options?: O
  ): RestResponse<WebResponseEntity<SettlementSettingDto>> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/settlement-setting/remove-master-agent-account`,
      data: requestDto,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/settlement-setting/start-scheduler
   * Java method: com.europoint.settlement.webapi.web.controllers.SettlementSettingController.startSchedule
   */
  startSchedule(options?: O): RestResponse<WebStringResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/settlement-setting/start-scheduler`,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/settlement-setting/stop-scheduler
   * Java method: com.europoint.settlement.webapi.web.controllers.SettlementSettingController.stopSchedule
   */
  stopSchedule(options?: O): RestResponse<WebStringResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/settlement-setting/stop-scheduler`,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/settlement-setting/test
   * Java method: com.europoint.settlement.webapi.web.controllers.SettlementSettingController.test
   */
  test$GET$settlement_settlementsetting_test(options?: O): RestResponse<WebStringResponse> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/settlement-setting/test`,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/settlement-setting/update
   * Java method: com.europoint.settlement.webapi.web.controllers.SettlementSettingController.update
   */
  update$POST$settlement_settlementsetting_update(
    settlementSettingDto: UpdateSettlementSettingDto,
    options?: O
  ): RestResponse<WebResponseEntity<SettlementSettingDto>> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/settlement-setting/update`,
      data: settlementSettingDto,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/western-union-processing/activity-file-process
   * Java method: com.europoint.settlement.webapi.web.controllers.WesternUnionProcessingController.activityFileProcess
   */
  activityFileProcess(
    queryParams: { activityDataHeaderId: string },
    options?: O
  ): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/western-union-processing/activity-file-process`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/western-union-processing/add-system-transaction-in-activity
   * Java method: com.europoint.settlement.webapi.web.controllers.WesternUnionProcessingController.addTransactionToActivity
   */
  addTransactionToActivity(
    queryParams: { activityProcessingResultId: string; systemTransactionId: string },
    options?: O
  ): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/western-union-processing/add-system-transaction-in-activity`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/western-union-processing/add-system-transaction-in-settlement
   * Java method: com.europoint.settlement.webapi.web.controllers.WesternUnionProcessingController.addTransactionToSettlement
   */
  addTransactionToSettlement(
    queryParams: { settlementProcessingResultId: string; systemTransactionId: string },
    options?: O
  ): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/western-union-processing/add-system-transaction-in-settlement`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/western-union-processing/confirm-all-processing-results
   * Java method: com.europoint.settlement.webapi.web.controllers.WesternUnionProcessingController.confirmAllProcessingResults
   */
  confirmAllProcessingResults(
    queryParams: { activityDataHeaderId: string },
    options?: O
  ): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/western-union-processing/confirm-all-processing-results`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/western-union-processing/confirm-processing-result
   * Java method: com.europoint.settlement.webapi.web.controllers.WesternUnionProcessingController.confirmProcessingResult
   */
  confirmProcessingResult(
    request: ConfirmProcessingResultRequest,
    options?: O
  ): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/western-union-processing/confirm-processing-result`,
      data: request,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/western-union-processing/create-settlement-transaction-parts
   * Java method: com.europoint.settlement.webapi.web.controllers.WesternUnionProcessingController.createSettlementTransactionParts
   */
  createSettlementTransactionParts(options?: O): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/western-union-processing/create-settlement-transaction-parts`,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/western-union-processing/get-activity-processing-result-by-mtcn
   * Java method: com.europoint.settlement.webapi.web.controllers.WesternUnionProcessingController.getActivityProcessingResult
   */
  getActivityProcessingResult(
    queryParams: { mtcn: string },
    options?: O
  ): RestResponse<WebResponseEntity<WesternUnionActivityProcessingResultDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/western-union-processing/get-activity-processing-result-by-mtcn`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/western-union-processing/get-matching-sys-transaction-list
   * Java method: com.europoint.settlement.webapi.web.controllers.WesternUnionProcessingController.getMatchingSysTransactionList
   */
  getMatchingSysTransactionList(
    queryParams: { activityDataHeaderId: string; conflictExists: boolean },
    options?: O
  ): RestResponse<WebListResponseEntity<WesternUnionActivityProcessingResultDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/western-union-processing/get-matching-sys-transaction-list`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/western-union-processing/get-non-matching-activity-payout-list
   * Java method: com.europoint.settlement.webapi.web.controllers.WesternUnionProcessingController.getNonMatchingActivityPayoutList
   */
  getNonMatchingActivityPayoutList(
    queryParams: { activityDataHeaderId: string },
    options?: O
  ): RestResponse<WebListResponseEntity<WesternUnionActivityProcessingResultDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/western-union-processing/get-non-matching-activity-payout-list`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/western-union-processing/get-non-matching-activity-send-list
   * Java method: com.europoint.settlement.webapi.web.controllers.WesternUnionProcessingController.getNonMatchingActivitySendList
   */
  getNonMatchingActivitySendList(
    queryParams: { activityDataHeaderId: string },
    options?: O
  ): RestResponse<WebListResponseEntity<WesternUnionActivityProcessingResultDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/western-union-processing/get-non-matching-activity-send-list`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/western-union-processing/get-non-matching-sys-transaction-list
   * Java method: com.europoint.settlement.webapi.web.controllers.WesternUnionProcessingController.getNonMatchingSysTransactionList
   */
  getNonMatchingSysTransactionList(
    queryParams: { date: DateAsString },
    options?: O
  ): RestResponse<WebListResponseEntity<WesternUnionTransactionDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/western-union-processing/get-non-matching-sys-transaction-list`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/western-union-processing/get-settlement-processing-result-by-mtcn
   * Java method: com.europoint.settlement.webapi.web.controllers.WesternUnionProcessingController.getSettlementProcessingResult
   */
  getSettlementProcessingResult(
    queryParams: { mtcn: string },
    options?: O
  ): RestResponse<WebListResponseEntity<WesternUnionSettlementProcessingResultDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/western-union-processing/get-settlement-processing-result-by-mtcn`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP GET /settlement/western-union-processing/get-system-transaction-by-mtcn
   * Java method: com.europoint.settlement.webapi.web.controllers.WesternUnionProcessingController.getSystemTransaction
   */
  getSystemTransaction(
    queryParams: { mtcn: string },
    options?: O
  ): RestResponse<WebResponseEntity<WesternUnionTransactionDto>> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`settlement/western-union-processing/get-system-transaction-by-mtcn`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/western-union-processing/remove-system-transaction-from-activity
   * Java method: com.europoint.settlement.webapi.web.controllers.WesternUnionProcessingController.removeTransactionFromActivity
   */
  removeTransactionFromActivity(
    queryParams: { activityProcessingResultId: string },
    options?: O
  ): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/western-union-processing/remove-system-transaction-from-activity`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/western-union-processing/remove-system-transaction-from-settlement
   * Java method: com.europoint.settlement.webapi.web.controllers.WesternUnionProcessingController.removeTransactionFromSettlement
   */
  removeTransactionFromSettlement(
    queryParams: { settlementProcessingResultId: string },
    options?: O
  ): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/western-union-processing/remove-system-transaction-from-settlement`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/western-union-processing/search-activity-processing-results
   * Java method: com.europoint.settlement.webapi.web.controllers.WesternUnionProcessingController.searchAllActivityProcessingResult
   */
  searchAllActivityProcessingResult(
    request: SearchRequest,
    options?: O
  ): RestResponse<Page<WesternUnionActivityProcessingResultDto>> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/western-union-processing/search-activity-processing-results`,
      data: request,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/western-union-processing/search-settlement-processing-results
   * Java method: com.europoint.settlement.webapi.web.controllers.WesternUnionProcessingController.searchAllSettlementProcessingResult
   */
  searchAllSettlementProcessingResult(
    request: SearchRequest,
    options?: O
  ): RestResponse<Page<WesternUnionSettlementProcessingResultDto>> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/western-union-processing/search-settlement-processing-results`,
      data: request,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/western-union-processing/settlement-file-process
   * Java method: com.europoint.settlement.webapi.web.controllers.WesternUnionProcessingController.settlementFileProcess
   */
  settlementFileProcess(
    queryParams: { settlementDataHeaderId: string },
    options?: O
  ): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/western-union-processing/settlement-file-process`,
      queryParams: queryParams,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/western-union-processing/update-system-transaction-in-settlement
   * Java method: com.europoint.settlement.webapi.web.controllers.WesternUnionProcessingController.updateConfirmedTransactionInSettlement
   */
  updateConfirmedTransactionInSettlement(
    transactionInfo: WesternUnionTransactionInfo,
    queryParams: { settlementProcessingResultId: string },
    options?: O
  ): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/western-union-processing/update-system-transaction-in-settlement`,
      queryParams: queryParams,
      data: transactionInfo,
      options: options,
    });
  }

  /**
   * HTTP POST /settlement/western-union-processing/update-transaction-info-in-activity
   * Java method: com.europoint.settlement.webapi.web.controllers.WesternUnionProcessingController.updateTransactionInfoInActivity
   */
  updateTransactionInfoInActivity(
    transactionInfo: WesternUnionTransactionInfo,
    queryParams: { activityProcessingResultId: string },
    options?: O
  ): RestResponse<WebBooleanResponse> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`settlement/western-union-processing/update-transaction-info-in-activity`,
      queryParams: queryParams,
      data: transactionInfo,
      options: options,
    });
  }
}

export type RestResponse<R> = Promise<Axios.GenericAxiosResponse<R>>;

export type DateAsString = string;

export const enum MoneyFlow {
  PAY_IN = 'PAY_IN',
  PAY_OUT = 'PAY_OUT',
  NONE = 'NONE',
}

/**
 * Values:
 * - `CONTINUE`
 * - `SWITCHING_PROTOCOLS`
 * - `PROCESSING`
 * - `CHECKPOINT`
 * - `OK`
 * - `CREATED`
 * - `ACCEPTED`
 * - `NON_AUTHORITATIVE_INFORMATION`
 * - `NO_CONTENT`
 * - `RESET_CONTENT`
 * - `PARTIAL_CONTENT`
 * - `MULTI_STATUS`
 * - `ALREADY_REPORTED`
 * - `IM_USED`
 * - `MULTIPLE_CHOICES`
 * - `MOVED_PERMANENTLY`
 * - `FOUND`
 * - `MOVED_TEMPORARILY` - @deprecated
 * - `SEE_OTHER`
 * - `NOT_MODIFIED`
 * - `USE_PROXY` - @deprecated
 * - `TEMPORARY_REDIRECT`
 * - `PERMANENT_REDIRECT`
 * - `BAD_REQUEST`
 * - `UNAUTHORIZED`
 * - `PAYMENT_REQUIRED`
 * - `FORBIDDEN`
 * - `NOT_FOUND`
 * - `METHOD_NOT_ALLOWED`
 * - `NOT_ACCEPTABLE`
 * - `PROXY_AUTHENTICATION_REQUIRED`
 * - `REQUEST_TIMEOUT`
 * - `CONFLICT`
 * - `GONE`
 * - `LENGTH_REQUIRED`
 * - `PRECONDITION_FAILED`
 * - `PAYLOAD_TOO_LARGE`
 * - `REQUEST_ENTITY_TOO_LARGE` - @deprecated
 * - `URI_TOO_LONG`
 * - `REQUEST_URI_TOO_LONG` - @deprecated
 * - `UNSUPPORTED_MEDIA_TYPE`
 * - `REQUESTED_RANGE_NOT_SATISFIABLE`
 * - `EXPECTATION_FAILED`
 * - `I_AM_A_TEAPOT`
 * - `INSUFFICIENT_SPACE_ON_RESOURCE` - @deprecated
 * - `METHOD_FAILURE` - @deprecated
 * - `DESTINATION_LOCKED` - @deprecated
 * - `UNPROCESSABLE_ENTITY`
 * - `LOCKED`
 * - `FAILED_DEPENDENCY`
 * - `TOO_EARLY`
 * - `UPGRADE_REQUIRED`
 * - `PRECONDITION_REQUIRED`
 * - `TOO_MANY_REQUESTS`
 * - `REQUEST_HEADER_FIELDS_TOO_LARGE`
 * - `UNAVAILABLE_FOR_LEGAL_REASONS`
 * - `INTERNAL_SERVER_ERROR`
 * - `NOT_IMPLEMENTED`
 * - `BAD_GATEWAY`
 * - `SERVICE_UNAVAILABLE`
 * - `GATEWAY_TIMEOUT`
 * - `HTTP_VERSION_NOT_SUPPORTED`
 * - `VARIANT_ALSO_NEGOTIATES`
 * - `INSUFFICIENT_STORAGE`
 * - `LOOP_DETECTED`
 * - `BANDWIDTH_LIMIT_EXCEEDED`
 * - `NOT_EXTENDED`
 * - `NETWORK_AUTHENTICATION_REQUIRED`
 */
export const enum HttpStatus {
  CONTINUE = 'CONTINUE',
  SWITCHING_PROTOCOLS = 'SWITCHING_PROTOCOLS',
  PROCESSING = 'PROCESSING',
  CHECKPOINT = 'CHECKPOINT',
  OK = 'OK',
  CREATED = 'CREATED',
  ACCEPTED = 'ACCEPTED',
  NON_AUTHORITATIVE_INFORMATION = 'NON_AUTHORITATIVE_INFORMATION',
  NO_CONTENT = 'NO_CONTENT',
  RESET_CONTENT = 'RESET_CONTENT',
  PARTIAL_CONTENT = 'PARTIAL_CONTENT',
  MULTI_STATUS = 'MULTI_STATUS',
  ALREADY_REPORTED = 'ALREADY_REPORTED',
  IM_USED = 'IM_USED',
  MULTIPLE_CHOICES = 'MULTIPLE_CHOICES',
  MOVED_PERMANENTLY = 'MOVED_PERMANENTLY',
  FOUND = 'FOUND',
  /**
   * @deprecated
   */
  MOVED_TEMPORARILY = 'MOVED_TEMPORARILY',
  SEE_OTHER = 'SEE_OTHER',
  NOT_MODIFIED = 'NOT_MODIFIED',
  /**
   * @deprecated
   */
  USE_PROXY = 'USE_PROXY',
  TEMPORARY_REDIRECT = 'TEMPORARY_REDIRECT',
  PERMANENT_REDIRECT = 'PERMANENT_REDIRECT',
  BAD_REQUEST = 'BAD_REQUEST',
  UNAUTHORIZED = 'UNAUTHORIZED',
  PAYMENT_REQUIRED = 'PAYMENT_REQUIRED',
  FORBIDDEN = 'FORBIDDEN',
  NOT_FOUND = 'NOT_FOUND',
  METHOD_NOT_ALLOWED = 'METHOD_NOT_ALLOWED',
  NOT_ACCEPTABLE = 'NOT_ACCEPTABLE',
  PROXY_AUTHENTICATION_REQUIRED = 'PROXY_AUTHENTICATION_REQUIRED',
  REQUEST_TIMEOUT = 'REQUEST_TIMEOUT',
  CONFLICT = 'CONFLICT',
  GONE = 'GONE',
  LENGTH_REQUIRED = 'LENGTH_REQUIRED',
  PRECONDITION_FAILED = 'PRECONDITION_FAILED',
  PAYLOAD_TOO_LARGE = 'PAYLOAD_TOO_LARGE',
  /**
   * @deprecated
   */
  REQUEST_ENTITY_TOO_LARGE = 'REQUEST_ENTITY_TOO_LARGE',
  URI_TOO_LONG = 'URI_TOO_LONG',
  /**
   * @deprecated
   */
  REQUEST_URI_TOO_LONG = 'REQUEST_URI_TOO_LONG',
  UNSUPPORTED_MEDIA_TYPE = 'UNSUPPORTED_MEDIA_TYPE',
  REQUESTED_RANGE_NOT_SATISFIABLE = 'REQUESTED_RANGE_NOT_SATISFIABLE',
  EXPECTATION_FAILED = 'EXPECTATION_FAILED',
  I_AM_A_TEAPOT = 'I_AM_A_TEAPOT',
  /**
   * @deprecated
   */
  INSUFFICIENT_SPACE_ON_RESOURCE = 'INSUFFICIENT_SPACE_ON_RESOURCE',
  /**
   * @deprecated
   */
  METHOD_FAILURE = 'METHOD_FAILURE',
  /**
   * @deprecated
   */
  DESTINATION_LOCKED = 'DESTINATION_LOCKED',
  UNPROCESSABLE_ENTITY = 'UNPROCESSABLE_ENTITY',
  LOCKED = 'LOCKED',
  FAILED_DEPENDENCY = 'FAILED_DEPENDENCY',
  TOO_EARLY = 'TOO_EARLY',
  UPGRADE_REQUIRED = 'UPGRADE_REQUIRED',
  PRECONDITION_REQUIRED = 'PRECONDITION_REQUIRED',
  TOO_MANY_REQUESTS = 'TOO_MANY_REQUESTS',
  REQUEST_HEADER_FIELDS_TOO_LARGE = 'REQUEST_HEADER_FIELDS_TOO_LARGE',
  UNAVAILABLE_FOR_LEGAL_REASONS = 'UNAVAILABLE_FOR_LEGAL_REASONS',
  INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR',
  NOT_IMPLEMENTED = 'NOT_IMPLEMENTED',
  BAD_GATEWAY = 'BAD_GATEWAY',
  SERVICE_UNAVAILABLE = 'SERVICE_UNAVAILABLE',
  GATEWAY_TIMEOUT = 'GATEWAY_TIMEOUT',
  HTTP_VERSION_NOT_SUPPORTED = 'HTTP_VERSION_NOT_SUPPORTED',
  VARIANT_ALSO_NEGOTIATES = 'VARIANT_ALSO_NEGOTIATES',
  INSUFFICIENT_STORAGE = 'INSUFFICIENT_STORAGE',
  LOOP_DETECTED = 'LOOP_DETECTED',
  BANDWIDTH_LIMIT_EXCEEDED = 'BANDWIDTH_LIMIT_EXCEEDED',
  NOT_EXTENDED = 'NOT_EXTENDED',
  NETWORK_AUTHENTICATION_REQUIRED = 'NETWORK_AUTHENTICATION_REQUIRED',
}

export const enum ReceivedPaymentType {
  MASTER_AGENT_PAYMENT = 'MASTER_AGENT_PAYMENT',
  AGENT_PAYMENT = 'AGENT_PAYMENT',
}

export const enum SettlementExchangeRateType {
  BID = 'BID',
  ASK = 'ASK',
  MID = 'MID',
  NONE = 'NONE',
}

export const enum ExchangeRateDate {
  NONE = 'NONE',
  TRANSACTION_DATE = 'TRANSACTION_DATE',
  SETTLEMENT_DATE = 'SETTLEMENT_DATE',
}

export const enum TransactionPartType {
  PRINCIPAL = 'PRINCIPAL',
  FEE = 'FEE',
  COMMISSION = 'COMMISSION',
  ALL = 'ALL',
}

export const enum SharingArrangementModelType {
  AGENT_MODEL = 'AGENT_MODEL',
  SERVICE_PROVIDER_MODEL = 'SERVICE_PROVIDER_MODEL',
}

export const enum DayOfWeek {
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
}

export const enum CounterResetPeriod {
  NONE = 'NONE',
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY',
  SEMIYEARLY = 'SEMIYEARLY',
  YEARLY = 'YEARLY',
}

export const enum SharingArrangementModelUnit {
  NONE = 'NONE',
  FEE_AMOUNT = 'FEE_AMOUNT',
  TX_AMOUNT = 'TX_AMOUNT',
  TX_COUNT = 'TX_COUNT',
}

export const enum DataType {
  BOOLEAN = 'BOOLEAN',
  STRING = 'STRING',
  DECIMAL = 'DECIMAL',
  LONG = 'LONG',
  INTEGER = 'INTEGER',
  INSTANT = 'INSTANT',
  DECIMAL_RANGE = 'DECIMAL_RANGE',
  LONG_RANGE = 'LONG_RANGE',
}

export const enum AdjustmentType {
  REVERSED = 'REVERSED',
  REPROCESSED = 'REPROCESSED',
  REVERSED_AND_THEN_REPROCESSED = 'REVERSED_AND_THEN_REPROCESSED',
}

export const enum AccountType {
  TRANSACTIONAL = 'TRANSACTIONAL',
  PURPOSE = 'PURPOSE',
  SPECIAL = 'SPECIAL',
  REGULAR = 'REGULAR',
  SAVINGS = 'SAVINGS',
  CREDIT = 'CREDIT',
}

export const enum AccountStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  CLOSED = 'CLOSED',
}

export const enum ReceivedPaymentState {
  RECEIVED = 'RECEIVED',
  PARTIALLY_SETTLED = 'PARTIALLY_SETTLED',
  SETTLED = 'SETTLED',
}

export const enum ProcessChannelType {
  Common = 'Common',
  Instant = 'Instant',
  Urgent = 'Urgent',
  Grouping = 'Grouping',
}

export const enum BusinessTransactionState {
  CREATED = 'CREATED',
  SHARING_ARRANGEMENT_PENDING = 'SHARING_ARRANGEMENT_PENDING',
  CALCULATED = 'CALCULATED',
  COMMISSION_SET = 'COMMISSION_SET',
  COMMISSION_PENDING = 'COMMISSION_PENDING',
  DUE_DATES_SET = 'DUE_DATES_SET',
  DUE_DATES_PENDING = 'DUE_DATES_PENDING',
  FINISHED = 'FINISHED',
  CANCELED = 'CANCELED',
}

export const enum SettlementTransactionType {
  PRINCIPAL_RECEIVABLE = 'PRINCIPAL_RECEIVABLE',
  FEE_RECEIVABLE = 'FEE_RECEIVABLE',
  PRINCIPAL_PAYABLE = 'PRINCIPAL_PAYABLE',
  COMMISSION_PAYABLE = 'COMMISSION_PAYABLE',
}

export const enum SettlementEntryState {
  CREATED = 'CREATED',
  PROCESSED = 'PROCESSED',
}

export const enum SettlementOrderEntryType {
  NEW_DEBIT = 'NEW_DEBIT',
  OLD_DEBIT = 'OLD_DEBIT',
  CREDIT = 'CREDIT',
}

export const enum SettlementOrderEntryState {
  CREATED = 'CREATED',
  INDEBTED = 'INDEBTED',
  NETTED = 'NETTED',
}

export const enum SettlementOrderRecipientType {
  AGENT = 'AGENT',
  MASTER_AGENT = 'MASTER_AGENT',
}

export const enum SettlementTransactionStatusType {
  DUE_DATE_CALCULATED = 'DUE_DATE_CALCULATED',
  IN_SETTLEMENT_PROCESS = 'IN_SETTLEMENT_PROCESS',
  PROCESSED = 'PROCESSED',
  PARTIALLY_SETTLED = 'PARTIALLY_SETTLED',
  SETTLED = 'SETTLED',
}

export const enum SettlementState {
  OPENED = 'OPENED',
  CLOSED = 'CLOSED',
}

export const enum Operator {
  EQUAL = 'EQUAL',
  NOT_EQUAL = 'NOT_EQUAL',
  LIKE = 'LIKE',
  NOT_LIKE = 'NOT_LIKE',
  STARTS_WITH = 'STARTS_WITH',
  END_WITH = 'END_WITH',
  IN = 'IN',
  NOT_IN = 'NOT_IN',
  GREATER_THAN = 'GREATER_THAN',
  GREATER_OR_EQUAL_TO = 'GREATER_OR_EQUAL_TO',
  LESS_THAN = 'LESS_THAN',
  LESS_OR_EQUAL_TO = 'LESS_OR_EQUAL_TO',
  BETWEEN = 'BETWEEN',
}

export const enum FieldType {
  BOOLEAN = 'BOOLEAN',
  CHAR = 'CHAR',
  DATE = 'DATE',
  INSTANT = 'INSTANT',
  DOUBLE = 'DOUBLE',
  INTEGER = 'INTEGER',
  LONG = 'LONG',
  STRING = 'STRING',
  UUID = 'UUID',
  ENUM_STRING = 'ENUM_STRING',
}

export const enum SortDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}

export const enum SettlementPlanType {
  PERIODIC = 'PERIODIC',
  CONTINUOUS = 'CONTINUOUS',
}

export const enum NettingType {
  PRINCIPAL_PRINCIPAL = 'PRINCIPAL_PRINCIPAL',
  FEE_COMMISSION = 'FEE_COMMISSION',
  ALL_ALL = 'ALL_ALL',
}

export const enum SettlementConfigurationStateType {
  CREATED = 'CREATED',
  FINISHED = 'FINISHED',
  ACTIVATED = 'ACTIVATED',
  DEACTIVATED = 'DEACTIVATED',
  DELETED = 'DELETED',
}

export const enum SharingArrangementStateType {
  CREATED = 'CREATED',
  FINISHED = 'FINISHED',
  ACTIVATED = 'ACTIVATED',
  DEACTIVATED = 'DEACTIVATED',
  DELETED = 'DELETED',
}

export const enum PartyType {
  NaturalPerson = 'NaturalPerson',
  LegalEntity = 'LegalEntity',
  Entrepreneur = 'Entrepreneur',
}

export const enum ActivityDataStatus {
  INBOUND = 'INBOUND',
  RE_INPUT = 'RE_INPUT',
  PAID_OR_DIRECTED = 'PAID_OR_DIRECTED',
  UNPAID = 'UNPAID',
  CANCELED = 'CANCELED',
  PURGED = 'PURGED',
  QUICK_PAY = 'QUICK_PAY',
  OTHER = 'OTHER',
}

export const enum SettlementDataDirection {
  INBOUND = 'INBOUND',
  OUTBOUND = 'OUTBOUND',
  INTRA_NETWORK_AGENT = 'INTRA_NETWORK_AGENT',
  INTRA_COUNTRY_INBOUND = 'INTRA_COUNTRY_INBOUND',
  INTRA_COUNTRY_OUTBOUND = 'INTRA_COUNTRY_OUTBOUND',
}

export const enum SettlementDataStatus {
  UNPAID = 'UNPAID',
  PAID = 'PAID',
  CANCELLED = 'CANCELLED',
  PURGED = 'PURGED',
  REFUND = 'REFUND',
}

export const enum DueDateConfigurationType {
  ROLLING_SETTLEMENT = 'ROLLING_SETTLEMENT',
  ACCOUNTING_SETTLEMENT = 'ACCOUNTING_SETTLEMENT',
  AMOUNT_WITH_ACCOUNTING_SETTLEMENT = 'AMOUNT_WITH_ACCOUNTING_SETTLEMENT',
  AMOUNT_WITH_ROLLING_SETTLEMENT = 'AMOUNT_WITH_ROLLING_SETTLEMENT',
}

export const enum SharingArrangementModelStateType {
  CREATING = 'CREATING',
  PARAMETRIZING = 'PARAMETRIZING',
  FORMING = 'FORMING',
  PREPARED = 'PREPARED',
  REJECTED = 'REJECTED',
  VERIFIED = 'VERIFIED',
  CLOSED = 'CLOSED',
  ACTIVATED = 'ACTIVATED',
  DEACTIVATING = 'DEACTIVATING',
  DEACTIVATED = 'DEACTIVATED',
  DELETED = 'DELETED',
}

export const enum Direction {
  ASC = 'ASC',
  DESC = 'DESC',
}

export const enum NullHandling {
  NATIVE = 'NATIVE',
  NULLS_FIRST = 'NULLS_FIRST',
  NULLS_LAST = 'NULLS_LAST',
}

export const enum DueDateType {
  T_PLUS_N = 'T_PLUS_N',
  PERIODIC_WEEKDAYS = 'PERIODIC_WEEKDAYS',
  PERIODIC_MONTH = 'PERIODIC_MONTH',
  PERIODIC_QUARTER = 'PERIODIC_QUARTER',
  PERIODIC_YEAR = 'PERIODIC_YEAR',
}

function uriEncoding(template: TemplateStringsArray, ...substitutions: any[]): string {
  let result = '';
  for (let i = 0; i < substitutions.length; i++) {
    result += template[i];
    result += encodeURIComponent(substitutions[i]);
  }
  result += template[template.length - 1];
  return result;
}

// Added by 'AxiosClientExtension' extension

import axios, * as Axios from 'axios';

declare module 'axios' {
  export interface GenericAxiosResponse<R> extends Axios.AxiosResponse {
    data: R;
  }
}

class AxiosHttpClient implements HttpClient<Axios.AxiosRequestConfig> {
  constructor(private axios: Axios.AxiosInstance) {}

  request<R>(requestConfig: {
    method: string;
    url: string;
    queryParams?: any;
    data?: any;
    copyFn?: (data: R) => R;
    options?: Axios.AxiosRequestConfig;
  }): RestResponse<R> {
    function assign(target: any, source?: any) {
      if (source != undefined) {
        for (const key in source) {
          if (source.hasOwnProperty(key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    }

    const config: Axios.AxiosRequestConfig = {};
    config.method = requestConfig.method as typeof config.method; // `string` in axios 0.16.0, `Method` in axios 0.19.0
    config.url = requestConfig.url;
    config.params = requestConfig.queryParams;
    config.data = requestConfig.data;
    assign(config, requestConfig.options);
    const copyFn = requestConfig.copyFn;

    const axiosResponse = this.axios.request(config);
    return axiosResponse.then((axiosResponse) => {
      if (copyFn && axiosResponse.data) {
        (axiosResponse as any).originalData = axiosResponse.data;
        axiosResponse.data = copyFn(axiosResponse.data);
      }
      return axiosResponse;
    });
  }
}

export class AxiosRestApplicationClient extends RestApplicationClient<Axios.AxiosRequestConfig> {
  constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
    axiosInstance.defaults.baseURL = baseURL;
    super(new AxiosHttpClient(axiosInstance));
  }
}
